(()=>{'use strict';if(typeof String.prototype.replaceAll!=='function'){Object.defineProperty(String.prototype,'replaceAll',{configurable:true,writable:true,value(search,replacement){if(search instanceof RegExp)return this.replace(search,replacement);return this.split(String(search)).join(String(replacement));},});}if(typeof Array.prototype.flatMap!=='function'){Object.defineProperty(Array.prototype,'flatMap',{configurable:true,writable:true,value(callback,thisArg){return this.reduce((result,item,index,array)=>result.concat(callback.call(thisArg,item,index,array)),[],);},});}if(typeof Object.fromEntries!=='function'){Object.fromEntries=function fromEntries(entries){const result={};Array.from(entries||[]).forEach((entry)=>{if(entry&&entry.length>=2)result[entry[0]]=entry[1];});return result;};}if(typeof window.AbortController!=='function'){class Z2AbortSignal extends EventTarget{constructor(){super();this.aborted=false;this.reason=undefined;}}class Z2AbortController{constructor(){this.signal=new Z2AbortSignal();}abort(reason){if(this.signal.aborted)return;this.signal.aborted=true;this.signal.reason=reason;this.signal.dispatchEvent(new Event('abort'));}}window.AbortController=Z2AbortController;}const VERSION='6.7.3';const GLOBAL_KEY='__z2ColumnProductShowcase';const ROOT_SELECTOR='[data-z2fc]';const COLUMN_SELECTOR='[data-z2fc-column]';const CARD_SELECTOR='[data-z2fc-product-card]';const TEMPLATE_SELECTOR='template[data-z2fc-candidate-template]';const LINK_SELECTOR='[data-z2fc-product-link]';const PRODUCT_IMAGE_SELECTOR='.z2fc__product-image-element';const BANNER_IMAGE_SELECTOR='[data-z2fc-banner-image]';const STORAGE_KEY='z2fc_interactions_v6';const LEGACY_STORAGE_KEYS=['z2fc_interactions_v5','z2fc_interactions_v4','z2fc_interactions_v3','z2fc_interactions_v2','z2fc_interactions_v1',];const INTERACTION_MODEL_VERSION=3;const MIN_COMPATIBLE_INTERACTION_MODEL=1;const CART_META_STORAGE_KEY='z2fc_cart_product_meta_v3';const INTERACTION_CHANNEL_NAME='z2fc-personalization-v6';const FATIGUE_STORAGE_KEY='z2fc_fatigue_v1';const EXPERIMENT_STORAGE_KEY='z2fc_experiment_v1';const METRICS_STORAGE_KEY='z2fc_experiment_metrics_v1';const SESSION_STORAGE_KEY='z2fc_session_v1';const NATIVE_CACHE_STORAGE_KEY='z2fc_native_recommendations_v1';const NATIVE_CONTEXT_CACHE_STORAGE_KEY='z2fc_native_context_v1';const VISITOR_STORAGE_KEY='z2fc_visitor_v1';const MAX_INTERACTIONS=48;const MAX_INTERACTION_TOKENS=56;const MAX_INTERACTION_CATEGORIES=8;const MAX_SESSION_IDS=12;const INTERACTION_TTL_MS=90*24*60*60*1000;const NEGATIVE_SIGNAL_TTL_MS=21*24*60*60*1000;const PURCHASE_SUPPRESSION_TTL_MS=35*24*60*60*1000;const FATIGUE_TTL_MS=35*24*60*60*1000;const CART_META_TTL_MS=30*60*1000;const NATIVE_CACHE_TTL_MS=20*60*1000;const REMOTE_PROFILE_CACHE_MS=5*60*1000;const CART_CACHE_MS=20_000;const RECENT_CART_SIGNAL_TTL_MS=10*60*1000;const REQUEST_TIMEOUT_MS=6_000;const PRIVACY_LOAD_TIMEOUT_MS=3_500;const MIN_SIGNAL_STRENGTH=5;const MIN_PERSONAL_BOOST=20;const INTERACTION_IDLE_MS=700;const COALESCE_MS=160;const SESSION_IDLE_MS=30*60*1000;const INTERSECTION_ROOT_MARGIN='600px 0px';const IMPRESSION_THRESHOLD=0.55;const MOBILE_LIFT_DELAY_MS=300;const MOBILE_LIFT_MOVE_TOLERANCE=10;const NATIVE_CONTEXT_CACHE_TTL_MS=60*60*1000;const NATIVE_CONTEXT_CONCURRENCY=4;const previous=window[GLOBAL_KEY];if(previous?.version===VERSION){previous.initialize(document);return;}previous?.destroyAll?.();const rootStates=new WeakMap();const initializedImages=new WeakSet();const globalLifecycle=new AbortController();const recentVariantSignals=new Map();const recordedReferrerHandles=new Set();const referrerRequests=new Map();const recordedCurrentPageHandles=new Set();const nativeRecommendationRequests=new Map();const remoteProfileRequests=new Map();const globalConfig=window.__Z2FC_CONFIG__||{};let globalRerunTimer=0;let pendingGlobalRerun=null;let cartRefreshTimer=0;let pendingCartRefresh=null;let previousCartItems=null;let interactionChannel=null;try{if('BroadcastChannel'in window){interactionChannel=new BroadcastChannel(INTERACTION_CHANNEL_NAME);}}catch(_error){interactionChannel=null;}let privacyReadyPromise=null;let ajaxCartRequest=null;let cartCache={summary:null,items:null,timestamp:0};const STOP_WORDS=new Set(['a','an','and','are','as','at','best','by','for','from','in','is','it','new','of','on','or','our','popular','portable','smart','the','this','to','top','with','your','rated','latest','everyday','product','products','item','items','pack','set','piece','pieces','plus','pro',]);const SHORT_TOKENS=new Set(['ai','vr','tv','4k','5g','usb','led','ev','gps','hd','ac','dc','qi','pc','xl','ios','car','fan',]);const TOKEN_ALIASES=new Map([['chargers','charging'],['charger','charging'],['charged','charging'],['powerbanks','powerbank'],['power-bank','powerbank'],['fans','cooling'],['fan','cooling'],['cooler','cooling'],['airflow','cooling'],['ventilation','cooling'],['massager','massage'],['massagers','massage'],['muscular','muscle'],['recovery','relief'],['therapy','relief'],['therapeutic','relief'],['cars','automotive'],['car','automotive'],['vehicle','automotive'],['vehicles','automotive'],['skincare','beauty'],['cosmetic','beauty'],['cosmetics','beauty'],['wellbeing','wellness'],['healthy','health'],['phones','mobile'],['phone','mobile'],['smartphone','mobile'],['smartphones','mobile'],['cellphone','mobile'],['headphones','audio'],['earbuds','audio'],['speaker','audio'],['speakers','audio'],['bluetooth','wireless'],['lamps','lighting'],['lamp','lighting'],['lights','lighting'],['cleaner','cleaning'],['cleaners','cleaning'],['holders','holder'],['mounts','mount'],]);const PHRASE_ALIASES=[[/(?:power\s+bank|battery\s+bank)/gu,' powerbank '],[/(?:car\s+charger|vehicle\s+charger)/gu,' carcharger '],[/(?:phone\s+holder|mobile\s+holder)/gu,' phoneholder '],[/(?:dash\s+cam|dashboard\s+camera)/gu,' dashcam '],[/(?:neck\s+fan|wearable\s+fan)/gu,' neckfan cooling '],[/(?:muscle\s+relief|pain\s+relief)/gu,' musclerelief relief '],[/(?:air\s+purifier|air\s+cleaner)/gu,' airpurifier cleaning '],[/(?:night\s+light|nightlight)/gu,' nightlight lighting '],[/(?:wireless\s+charger|wireless\s+charging)/gu,' wirelesscharging charging '],];const PROFILE_TERM_LISTS={top_rated_tech:['tech','technology','electronic','electronics','gadget','digital','charging','powerbank','wireless','mobile','audio','cooling','usb','led','lighting','camera','gaming','computer','smartwatch','tablet',],popular_tech:['tech','technology','electronic','electronics','gadget','digital','charging','powerbank','wireless','mobile','audio','cooling','usb','led','lighting','camera','gaming','computer','smartwatch','tablet',],popular_health_beauty:['health','beauty','wellness','massage','muscle','relief','skin','hair','personalcare','selfcare','fitness','recovery','therapy','grooming','cosmetic','body','care',],popular_car:['automotive','vehicle','driving','road','carcharger','dashcam','phoneholder','mount','cleaning','interior','safety','tire','seat','organizer','garage','travel',],collection:[],};const safeJsonParse=(value,fallback)=>{try{return JSON.parse(value);}catch(_error){return fallback;}};const normalizeText=(value)=>String(value||'').normalize('NFKD').replace(/\p{M}+/gu,'').trim().toLocaleLowerCase();const canonicalToken=(token)=>TOKEN_ALIASES.get(token)||token;const tokenize=(value)=>{let normalized=normalizeText(value);PHRASE_ALIASES.forEach(([pattern,replacement])=>{normalized=normalized.replace(pattern,replacement);});return[...new Set(normalized.replace(/[^\p{L}\p{N}]+/gu,' ').split(/\s+/u).filter(Boolean).map(canonicalToken).filter((token)=>{const length=[...token].length;return!STOP_WORDS.has(token)&&(length>2||SHORT_TOKENS.has(token));}).slice(0,100),)];};const PROFILE_TERMS=Object.fromEntries(Object.entries(PROFILE_TERM_LISTS).map(([profile,terms])=>[profile,new Set(terms.flatMap(tokenize)),]),);const CATEGORY_PROFILE_MAP={tech:['top_rated_tech','popular_tech'],health_beauty:['popular_health_beauty'],car:['popular_car'],};const PROFILE_CATEGORY_GATES={top_rated_tech:'tech',popular_tech:'tech',popular_health_beauty:'health_beauty',popular_car:'car',collection:'any',};const CATEGORY_SIGNAL_TERM_LISTS={tech:['tech','technology','electronic','electronics','gadget','digital','charging','charger','powerbank','wireless','mobile','audio','usb','led','lighting','camera','gaming','computer','smartwatch','tablet','keyboard','mouse','speaker','earbuds','headphones','projector','robot','smart home','bluetooth','wifi','magnetic charger','screen','clicker','device','remote control','type c',],health_beauty:['health','beauty','wellness','massage','massager','muscle','relief','skin','skincare','hair','personal care','self care','fitness','recovery','therapy','grooming','cosmetic','body','posture','lumbar','cervical','foot','knee','neck','pain','orthopedic','ergonomic','spa','facial','nail','makeup','shaver','oral care',],car:['automotive','vehicle','driving','road','car charger','dash cam','dashcam','obd','tire','windshield','trunk','steering','garage','parking','seat belt','seatbelt','carplay','car mount','auto','car accessory','car accessories','vehicle organizer','car cleaning','rearview','rear view','license plate','jump starter','air compressor',],};const CATEGORY_SIGNAL_TERMS=Object.fromEntries(Object.entries(CATEGORY_SIGNAL_TERM_LISTS).map(([category,terms])=>[category,new Set(terms.flatMap(tokenize)),]),);const APPROVED_DEAL_CATEGORIES=new Set(['tech','health_beauty','car']);const TRUSTED_CURATED_SOURCES=new Set(['manual','primary','fallback']);const inferCategoriesFromTokens=(tokens)=>{const tokenSet=new Set(Array.isArray(tokens)?tokens:[]);const ranked=Object.entries(CATEGORY_PROFILE_MAP).map(([category,profiles])=>{const terms=new Set(profiles.flatMap((profile)=>[...(PROFILE_TERMS[profile]||[])]));const matches=[...tokenSet].filter((token)=>terms.has(token)).length;return{category,matches};}).filter((item)=>item.matches>0).sort((left,right)=>right.matches-left.matches).map((item)=>item.category);return ranked.slice(0,MAX_INTERACTION_CATEGORIES);};const numeric=(value)=>{const parsed=Number(value);return Number.isFinite(parsed)?parsed:0;};const z2fcFormatMoney=(cents)=>{const value=Math.max(0,numeric(cents));try{if(window.Shopify&&typeof window.Shopify.formatMoney==='function')return window.Shopify.formatMoney(value,(window.theme&&window.theme.moneyFormat)||window.Shopify.money_format); }catch(_error){}const amount=value/100;const currency=window.Shopify?.currency?.active||'USD';try{return new Intl.NumberFormat(document.documentElement.lang||undefined,{style:'currency',currency}).format(amount);}catch(_error){return'$'+amount.toFixed(2);}};const boundedString=(value,maxLength)=>{if(typeof value!=='string')return'';return value.slice(0,maxLength);};const normalizeId=(value)=>{const raw=String(value||'').trim();if(!raw)return'';const parts=raw.split('/');return parts[parts.length-1].split('?')[0];};const createAbortError=()=>{try{return new DOMException('The operation was aborted.','AbortError');}catch(_error){const error=new Error('The operation was aborted.');error.name='AbortError';return error;}};const awaitWithSignal=(promise,signal)=>{if(!signal)return promise;if(signal.aborted)return Promise.reject(signal.reason||createAbortError());return new Promise((resolve,reject)=>{const abort=()=>reject(signal.reason||createAbortError());signal.addEventListener('abort',abort,{once:true});promise.then((value)=>{signal.removeEventListener('abort',abort);resolve(value);},(error)=>{signal.removeEventListener('abort',abort);reject(error);},);});};const fetchJson=async(url,options={},timeoutMs=REQUEST_TIMEOUT_MS)=>{const controller=new AbortController();const externalSignal=options.signal;const timeout=window.setTimeout(()=>controller.abort(createAbortError()),timeoutMs,);const abortFromExternal=()=>controller.abort(externalSignal.reason||createAbortError());if(externalSignal){if(externalSignal.aborted)abortFromExternal();else externalSignal.addEventListener('abort',abortFromExternal,{once:true});}try{const response=await fetch(url,{...options,signal:controller.signal});if(!response.ok)throw new Error(`Request failed: ${response.status}`);
      return await response.json();
    } finally {
      window.clearTimeout(timeout);
      externalSignal?.removeEventListener('abort', abortFromExternal);
    }
  };

  const fetchText = async (url, options = {}, timeoutMs = REQUEST_TIMEOUT_MS) => {
    const controller = new AbortController();
    const externalSignal = options.signal;
    const timeout = window.setTimeout(
      () => controller.abort(createAbortError()),
      timeoutMs,
    );
    const abortFromExternal = () =>
      controller.abort(externalSignal.reason || createAbortError());

    if (externalSignal) {
      if (externalSignal.aborted) abortFromExternal();
      else externalSignal.addEventListener('abort', abortFromExternal, { once: true });
    }

    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      if (!response.ok) throw new Error(`Request failed:${response.status}`);
      return await response.text();
    } finally {
      window.clearTimeout(timeout);
      externalSignal?.removeEventListener('abort', abortFromExternal);
    }
  };

  const customerPrivacyAvailable = () => Boolean(window.Shopify?.customerPrivacy);

  const ensureCustomerPrivacy = () => {
    if (customerPrivacyAvailable()) return Promise.resolve(true);
    if (privacyReadyPromise) return privacyReadyPromise;

    privacyReadyPromise = new Promise((resolve) => {
      let settled = false;
      let timeout = 0;

      const finish = () => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        resolve(customerPrivacyAvailable());
      };

      document.addEventListener('shopifyCustomerPrivacyApiLoaded', finish, {
        once: true,
        signal: globalLifecycle.signal,
      });

      timeout = window.setTimeout(finish, PRIVACY_LOAD_TIMEOUT_MS);

      if (typeof window.Shopify?.loadFeatures === 'function') {
        try {
          window.Shopify.loadFeatures(
            [{ name: 'consent-tracking-api', version: '0.1' }],
            finish,
          );
        } catch (_error) {
          finish();
        }
      }
    });

    return privacyReadyPromise;
  };

  const getPrivacyPermissions = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return { preferences: false, analytics: false };

    try {
      return {
        preferences: privacy.preferencesProcessingAllowed() === true,
        analytics: privacy.analyticsProcessingAllowed() === true,
      };
    } catch (_error) {
      return { preferences: false, analytics: false };
    }
  };

  const behaviorTrackingAllowed = () => {
    const permissions = getPrivacyPermissions();
    return permissions.preferences && permissions.analytics;
  };

  const randomId = () => {
    try {
      return crypto.randomUUID();
    } catch (_error) {
      return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2,12)}`;
    }
  };

  const getSessionId = () => {
    const now = Date.now();
    try {
      const current = safeJsonParse(localStorage.getItem(SESSION_STORAGE_KEY), null);
      if (
        current?.id &&
        Number.isFinite(Number(current.lastActivity)) &&
        now - Number(current.lastActivity) <= SESSION_IDLE_MS
      ) {
        localStorage.setItem(
          SESSION_STORAGE_KEY,
          JSON.stringify({ id: current.id, lastActivity: now }),
        );
        return current.id;
      }
      const id = randomId();
      localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify({ id, lastActivity: now }));
      return id;
    } catch (_error) {
      return `session-${Math.floor(now/SESSION_IDLE_MS)}`;
    }
  };

  const getVisitorId = () => {
    try {
      const existing = boundedString(localStorage.getItem(VISITOR_STORAGE_KEY), 120).trim();
      if (existing) return existing;
      const created = randomId();
      localStorage.setItem(VISITOR_STORAGE_KEY, created);
      return created;
    } catch (_error) {
      return '';
    }
  };

  const sanitizeStringArray = (value, maxItems, maxLength = 80) => {
    const source = Array.isArray(value) ? value : [];
    return [...new Set(
      source
        .map((item) => boundedString(item, maxLength).trim())
        .filter(Boolean),
    )].slice(0, maxItems);
  };

  const compactSignalFromProduct = (product = {}) => {
    const explicitTokens = sanitizeStringArray(product.tokens, MAX_INTERACTION_TOKENS);
    const tokens = explicitTokens.length
      ? explicitTokens
      : tokenize([
          product.title,
          product.type,
          product.vendor,
          String(product.tags || '').replaceAll('||', ' '),
          product.category,
          product.collections,
          product.keywords,
        ].filter(Boolean).join(' ')).slice(0, MAX_INTERACTION_TOKENS);
    const explicitCategories = sanitizeStringArray(
      product.categories,
      MAX_INTERACTION_CATEGORIES,
      50,
    );
    return {
      handle: boundedString(product.handle, 255).trim(),
      productId: normalizeId(product.productId || product.id),
      variantId: normalizeId(product.variantId),
      tokens,
      categories: explicitCategories.length
        ? explicitCategories
        : inferCategoriesFromTokens(tokens),
    };
  };

  const legacyInteractionToCompact = (item, sourceModelVersion) => {
    if (!item || typeof item !== 'object') return null;
    const timestamp = Number(item.timestamp || item.lastInteraction);
    const signal = compactSignalFromProduct(item);
    if (!signal.handle || !Number.isFinite(timestamp)) return null;
    const kind = ['view', 'add', 'remove', 'purchase'].includes(item.kind)
      ? item.kind
      : 'view';
    return {
      modelVersion: INTERACTION_MODEL_VERSION,
      ...signal,
      viewCount: kind === 'view' ? 1 : 0,
      addCount: kind === 'add' ? 1 : 0,
      removeCount: kind === 'remove' ? 1 : 0,
      purchaseCount: kind === 'purchase' ? 1 : 0,
      firstInteraction: timestamp,
      lastInteraction: timestamp,
      engagementWeight: kind === 'add' ? 4 : kind === 'purchase' ? 8 : kind === 'remove' ? 0 : 1,
      sessionCount: 1,
      sessionIds: [],
      lastKind: kind,
      lastRemove: kind === 'remove' ? timestamp : 0,
      lastPurchase: kind === 'purchase' ? timestamp : 0,
      migratedFrom: sourceModelVersion,
    };
  };

  const sanitizeInteraction = (
    item,
    now = Date.now(),
    sourceModelVersion = INTERACTION_MODEL_VERSION,
  ) => {
    if (!item || typeof item !== 'object') return null;
    if (
      sourceModelVersion < MIN_COMPATIBLE_INTERACTION_MODEL ||
      sourceModelVersion > INTERACTION_MODEL_VERSION
    ) {
      return null;
    }

    const raw = sourceModelVersion < 3 || Number(item.modelVersion) < 3
      ? legacyInteractionToCompact(item, sourceModelVersion)
      : item;
    if (!raw) return null;

    const signal = compactSignalFromProduct(raw);
    const firstInteraction = Number(raw.firstInteraction || raw.lastInteraction);
    const lastInteraction = Number(raw.lastInteraction || raw.timestamp);
    if (!signal.handle || !Number.isFinite(firstInteraction) || !Number.isFinite(lastInteraction)) {
      return null;
    }
    if (lastInteraction > now + 60_000 || now - lastInteraction > INTERACTION_TTL_MS) return null;

    const viewCount = Math.max(0, Math.min(10_000, Math.floor(numeric(raw.viewCount))));
    const addCount = Math.max(0, Math.min(10_000, Math.floor(numeric(raw.addCount))));
    const removeCount = Math.max(0, Math.min(10_000, Math.floor(numeric(raw.removeCount))));
    const purchaseCount = Math.max(0, Math.min(10_000, Math.floor(numeric(raw.purchaseCount))));
    const sessionIds = sanitizeStringArray(raw.sessionIds, MAX_SESSION_IDS, 120);

    return {
      modelVersion: INTERACTION_MODEL_VERSION,
      ...signal,
      viewCount,
      addCount,
      removeCount,
      purchaseCount,
      firstInteraction: Math.min(firstInteraction, lastInteraction),
      lastInteraction,
      engagementWeight: Math.max(
        0,
        Math.min(100_000, numeric(raw.engagementWeight) || viewCount + addCount * 4 + purchaseCount * 8),
      ),
      sessionCount: Math.max(
        sessionIds.length ? 1 : 0,
        Math.min(10_000, Math.floor(numeric(raw.sessionCount) || (sessionIds.length ? 1 : 0))),
      ),
      sessionIds,
      lastKind: ['view', 'add', 'remove', 'purchase'].includes(raw.lastKind)
        ? raw.lastKind
        : 'view',
      lastRemove: Math.max(0, numeric(raw.lastRemove)),
      lastPurchase: Math.max(0, numeric(raw.lastPurchase)),
    };
  };

  const mergeInteractionRecords = (left, right) => {
    if (!left) return right;
    if (!right) return left;
    const newest = right.lastInteraction >= left.lastInteraction ? right : left;
    const mergedSessionIds = [...new Set([
      ...(left.sessionIds || []),
      ...(right.sessionIds || []),
    ])].slice(-MAX_SESSION_IDS);
    return sanitizeInteraction({
      ...left,
      ...newest,
      tokens: [...new Set([...(left.tokens || []), ...(right.tokens || [])])],
      categories: [...new Set([...(left.categories || []), ...(right.categories || [])])],
      viewCount: numeric(left.viewCount) + numeric(right.viewCount),
      addCount: numeric(left.addCount) + numeric(right.addCount),
      removeCount: numeric(left.removeCount) + numeric(right.removeCount),
      purchaseCount: numeric(left.purchaseCount) + numeric(right.purchaseCount),
      firstInteraction: Math.min(left.firstInteraction, right.firstInteraction),
      lastInteraction: Math.max(left.lastInteraction, right.lastInteraction),
      engagementWeight: numeric(left.engagementWeight) + numeric(right.engagementWeight),
      sessionCount: Math.max(
        numeric(left.sessionCount),
        numeric(right.sessionCount),
        mergedSessionIds.length,
      ),
      sessionIds: mergedSessionIds,
      lastRemove: Math.max(numeric(left.lastRemove), numeric(right.lastRemove)),
      lastPurchase: Math.max(numeric(left.lastPurchase), numeric(right.lastPurchase)),
    });
  };

  const interactionPayload = (items) => ({
    modelVersion: INTERACTION_MODEL_VERSION,
    items: items
      .slice()
      .sort((left, right) => right.lastInteraction - left.lastInteraction)
      .slice(0, MAX_INTERACTIONS),
  });

  const removeStoredInteractions = () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
      LEGACY_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
      localStorage.removeItem(FATIGUE_STORAGE_KEY);
      localStorage.removeItem(EXPERIMENT_STORAGE_KEY);
      localStorage.removeItem(METRICS_STORAGE_KEY);
      localStorage.removeItem(SESSION_STORAGE_KEY);
      localStorage.removeItem(VISITOR_STORAGE_KEY);
      sessionStorage.removeItem(SESSION_INTERACTION_STORAGE_KEY);
      sessionStorage.removeItem(CART_META_STORAGE_KEY);
      sessionStorage.removeItem(NATIVE_CACHE_STORAGE_KEY);
    } catch (_error) {
      // Best-effort cleanup.
    }
  };

  const normalizeInteractionPayload = (raw) => {
    const parsed = safeJsonParse(raw, null);
    if (parsed === null) return [];
    const sourceModelVersion = Array.isArray(parsed)
      ? 1
      : numeric(parsed?.modelVersion) || 1;
    const sourceItems = Array.isArray(parsed) ? parsed : parsed?.items;
    if (
      !Array.isArray(sourceItems) ||
      sourceModelVersion < MIN_COMPATIBLE_INTERACTION_MODEL ||
      sourceModelVersion > INTERACTION_MODEL_VERSION
    ) return [];

    const now = Date.now();
    const grouped = new Map();
    sourceItems.forEach((item) => {
      const sanitized = sanitizeInteraction(item, now, sourceModelVersion);
      if (!sanitized) return;
      grouped.set(
        sanitized.handle,
        mergeInteractionRecords(grouped.get(sanitized.handle), sanitized),
      );
    });
    return [...grouped.values()]
      .filter(Boolean)
      .sort((left, right) => right.lastInteraction - left.lastInteraction)
      .slice(0, MAX_INTERACTIONS);
  };

  const writeInteractions = (items) => {
    const normalized = normalizeInteractionPayload(JSON.stringify(interactionPayload(items)));
    sessionInteractionMemory = normalized;
    try {
      if (getPrivacyPermissions().preferences) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(interactionPayload(normalized)));
        LEGACY_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
        sessionStorage.removeItem(SESSION_INTERACTION_STORAGE_KEY);
      } else {
        sessionStorage.setItem(
          SESSION_INTERACTION_STORAGE_KEY,
          JSON.stringify(interactionPayload(normalized)),
        );
      }
    } catch (_error) {
      // The in-memory copy still powers the current page.
    }
  };

  const readInteractions = () => {
    try {
      let localItems = [];
      let sessionItems = normalizeInteractionPayload(
        sessionStorage.getItem(SESSION_INTERACTION_STORAGE_KEY),
      );

      if (getPrivacyPermissions().preferences) {
        let raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) {
          const legacyKey = LEGACY_STORAGE_KEYS.find((key) => localStorage.getItem(key));
          raw = legacyKey ? localStorage.getItem(legacyKey) : null;
        }
        localItems = normalizeInteractionPayload(raw);
      }

      const grouped = new Map();
      [...localItems, ...sessionItems, ...sessionInteractionMemory].forEach((item) => {
        grouped.set(item.handle, mergeInteractionRecords(grouped.get(item.handle), item));
      });
      const merged = [...grouped.values()]
        .filter(Boolean)
        .sort((left, right) => right.lastInteraction - left.lastInteraction)
        .slice(0, MAX_INTERACTIONS);

      sessionInteractionMemory = merged;
      if (getPrivacyPermissions().preferences && sessionItems.length) writeInteractions(merged);
      return merged;
    } catch (_error) {
      return sessionInteractionMemory.slice();
    }
  };

  const productFromElement = (element) => ({
    handle: element?.dataset?.productHandle || '',
    productId: element?.dataset?.productId || '',
    variantId: element?.dataset?.variantId || '',
    title: element?.dataset?.productTitle || '',
    type: element?.dataset?.productType || '',
    vendor: element?.dataset?.productVendor || '',
    tags: element?.dataset?.productTags || '',
    category: element?.dataset?.productCategory || '',
    collections: element?.dataset?.productCollections || '',
    keywords: element?.dataset?.productKeywords || '',
    url: element?.dataset?.productUrl || '',
  });

  const publishInteractionUpdate = (handle = '') => {
    try {
      interactionChannel?.postMessage({
        type: 'interaction-update',
        handle,
        modelVersion: INTERACTION_MODEL_VERSION,
        timestamp: Date.now(),
      });
    } catch (_error) {
      // Cross-tab synchronization is an enhancement only.
    }
  };

  const recordInteraction = (kind, product, { broadcast = true } = {}) => {
    if (!product?.handle) return false;
    if (!['view', 'add', 'remove', 'purchase'].includes(kind)) return false;

    const now = Date.now();
    const sessionId = getSessionId();
    const signal = compactSignalFromProduct(product);
    if (!signal.handle) return false;
    const interactions = readInteractions();
    const existingIndex = interactions.findIndex((item) => item.handle === signal.handle);
    const existing = existingIndex >= 0 ? interactions[existingIndex] : null;
    const sessionIds = [...new Set([...(existing?.sessionIds || []), sessionId])].slice(-MAX_SESSION_IDS);
    const isNewSession = !existing?.sessionIds?.includes(sessionId);
    const candidate = sanitizeInteraction({
      modelVersion: INTERACTION_MODEL_VERSION,
      ...existing,
      ...signal,
      tokens: [...new Set([...(existing?.tokens || []), ...signal.tokens])],
      categories: [...new Set([...(existing?.categories || []), ...signal.categories])],
      viewCount: numeric(existing?.viewCount) + (kind === 'view' ? 1 : 0),
      addCount: numeric(existing?.addCount) + (kind === 'add' ? 1 : 0),
      removeCount: numeric(existing?.removeCount) + (kind === 'remove' ? 1 : 0),
      purchaseCount: numeric(existing?.purchaseCount) + (kind === 'purchase' ? 1 : 0),
      firstInteraction: existing?.firstInteraction || now,
      lastInteraction: now,
      engagementWeight:
        numeric(existing?.engagementWeight) +
        (kind === 'add' ? 4 : kind === 'purchase' ? 8 : kind === 'view' ? 1 : 0),
      sessionCount: numeric(existing?.sessionCount) + (isNewSession ? 1 : 0),
      sessionIds,
      lastKind: kind,
      lastRemove: kind === 'remove' ? now : numeric(existing?.lastRemove),
      lastPurchase: kind === 'purchase' ? now : numeric(existing?.lastPurchase),
    }, now, INTERACTION_MODEL_VERSION);
    if (!candidate) return false;

    if (existingIndex >= 0) interactions.splice(existingIndex, 1);
    writeInteractions([candidate, ...interactions]);
    if (broadcast) publishInteractionUpdate(candidate.handle);
    return true;
  };

  const sanitizeFatigueRecord = (item, now = Date.now()) => {
    if (!item || typeof item !== 'object') return null;
    const handle = boundedString(item.handle, 255).trim();
    const lastShown = numeric(item.lastShown);
    const lastAction = numeric(item.lastAction);
    if (!handle || (!lastShown && !lastAction)) return null;
    if (now - Math.max(lastShown, lastAction) > FATIGUE_TTL_MS) return null;
    return {
      handle,
      impressions: Math.max(0, Math.min(10_000, Math.floor(numeric(item.impressions)))),
      unengaged: Math.max(0, Math.min(1_000, Math.floor(numeric(item.unengaged)))),
      clicks: Math.max(0, Math.min(10_000, Math.floor(numeric(item.clicks)))),
      adds: Math.max(0, Math.min(10_000, Math.floor(numeric(item.adds)))),
      lastShown,
      lastAction,
      tokens: sanitizeStringArray(item.tokens, 24),
      categories: sanitizeStringArray(item.categories, MAX_INTERACTION_CATEGORIES, 50),
    };
  };

  const readFatigue = () => {
    if (!behaviorTrackingAllowed()) return new Map();
    try {
      const parsed = safeJsonParse(localStorage.getItem(FATIGUE_STORAGE_KEY), []);
      const records = Array.isArray(parsed) ? parsed : parsed?.items;
      if (!Array.isArray(records)) return new Map();
      const now = Date.now();
      return new Map(
        records
          .map((item) => sanitizeFatigueRecord(item, now))
          .filter(Boolean)
          .map((item) => [item.handle, item]),
      );
    } catch (_error) {
      return new Map();
    }
  };

  const writeFatigue = (records) => {
    if (!behaviorTrackingAllowed()) return;
    try {
      const items = [...records.values()]
        .sort((left, right) => Math.max(right.lastShown, right.lastAction) - Math.max(left.lastShown, left.lastAction))
        .slice(0, 80);
      localStorage.setItem(FATIGUE_STORAGE_KEY, JSON.stringify({ version: 1, items }));
    } catch (_error) {
      // Best effort.
    }
  };

  const recordFatigueImpression = (product) => {
    if (!behaviorTrackingAllowed() || !product?.handle) return;
    const signal = compactSignalFromProduct(product);
    const records = readFatigue();
    const current = records.get(signal.handle) || {
      handle: signal.handle,
      impressions: 0,
      unengaged: 0,
      clicks: 0,
      adds: 0,
      lastShown: 0,
      lastAction: 0,
      tokens: [],
      categories: [],
    };
    current.impressions += 1;
    current.unengaged += 1;
    current.lastShown = Date.now();
    current.tokens = [...new Set([...current.tokens, ...signal.tokens])].slice(0, 24);
    current.categories = [...new Set([...current.categories, ...signal.categories])].slice(0, MAX_INTERACTION_CATEGORIES);
    records.set(signal.handle, current);
    writeFatigue(records);
  };

  const recordFatigueAction = (product, kind) => {
    if (!behaviorTrackingAllowed() || !product?.handle) return;
    const signal = compactSignalFromProduct(product);
    const records = readFatigue();
    const current = records.get(signal.handle) || {
      handle: signal.handle,
      impressions: 0,
      unengaged: 0,
      clicks: 0,
      adds: 0,
      lastShown: 0,
      lastAction: 0,
      tokens: [],
      categories: [],
    };
    if (kind === 'click') current.clicks += 1;
    if (kind === 'add' || kind === 'purchase') current.adds += 1;
    current.unengaged = 0;
    current.lastAction = Date.now();
    current.tokens = [...new Set([...current.tokens, ...signal.tokens])].slice(0, 24);
    current.categories = [...new Set([...current.categories, ...signal.categories])].slice(0, MAX_INTERACTION_CATEGORIES);
    records.set(signal.handle, current);
    writeFatigue(records);
  };

  const getExperimentAssignment = (root) => {
    const holdoutPercentage = Math.max(
      0,
      Math.min(30, numeric(root?.dataset?.holdoutPercentage)),
    );
    if (holdoutPercentage === 0) return { group: 'personalized', bucket: 100 };
    try {
      const storage = getPrivacyPermissions().preferences ? localStorage : sessionStorage;
      const parsed = safeJsonParse(storage.getItem(EXPERIMENT_STORAGE_KEY), null);
      const bucket = Number.isFinite(Number(parsed?.bucket))
        ? Math.max(0, Math.min(99, Math.floor(Number(parsed.bucket))))
        : Math.floor(Math.random() * 100);
      const payload = { version: 1, bucket, assignedAt: numeric(parsed?.assignedAt) || Date.now() };
      storage.setItem(EXPERIMENT_STORAGE_KEY, JSON.stringify(payload));
      return { group: bucket < holdoutPercentage ? 'holdout' : 'personalized', bucket };
    } catch (_error) {
      return { group: 'personalized', bucket: 100 };
    }
  };

  const readMetrics = () => {
    try {
      const parsed = safeJsonParse(localStorage.getItem(METRICS_STORAGE_KEY), null);
      return parsed && typeof parsed === 'object'
        ? parsed
        : { version: 1, personalized: {}, holdout: {} };
    } catch (_error) {
      return { version: 1, personalized: {}, holdout: {} };
    }
  };

  const recordMetric = (root, eventName, product = {}) => {
    if (!analyticsTrackingAllowed()) return;
    const assignment = getExperimentAssignment(root);
    if (!['personalized', 'holdout'].includes(assignment.group)) return;
    try {
      const metrics = readMetrics();
      const group = metrics[assignment.group] || {};
      group[eventName] = numeric(group[eventName]) + 1;
      group.lastEventAt = Date.now();
      metrics[assignment.group] = group;
      metrics.version = 1;
      localStorage.setItem(METRICS_STORAGE_KEY, JSON.stringify(metrics));
    } catch (_error) {
      // Local experiment metrics are best effort.
    }
    sendRemoteEvent(root, eventName, product, assignment);
  };

  const remoteSyncEnabled = (root) =>
    root?.dataset?.remoteSync === 'true' || globalConfig.remoteSync === true;

  const remoteProfileBase = (root) => {
    const configured = boundedString(
      root?.dataset?.remoteProfilePath || globalConfig.remoteProfilePath || '',
      500,
    ).trim();
    if (!configured) return '';
    return configured.replace(/\/$/u, '');
  };

  const sendRemoteEvent = (root, eventName, product = {}, assignment = null) => {
    if (!analyticsTrackingAllowed() || !remoteSyncEnabled(root)) return;
    const base = remoteProfileBase(root);
    if (!base) return;
    const signal = compactSignalFromProduct(product);
    const body = {
      version: 1,
      eventId: randomId(),
      event: eventName,
      visitorId: getVisitorId(),
      sessionId: getSessionId(),
      experiment: assignment || getExperimentAssignment(root),
      product: signal,
      timestamp: Date.now(),
    };
    try {
      fetch(`${base}/events`, {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).catch(() => {});
    } catch (_error) {
      // Optional server sync must never affect the storefront.
    }
  };

  const sanitizeRemoteProfile = (payload) => {
    if (!payload || typeof payload !== 'object') return { interactions: [], purchasedHandles: new Set() };
    const now = Date.now();
    const interactions = (Array.isArray(payload.interactions) ? payload.interactions : [])
      .map((item) => sanitizeInteraction(item, now, INTERACTION_MODEL_VERSION))
      .filter(Boolean)
      .slice(0, MAX_INTERACTIONS);
    const purchasedHandles = new Set(
      sanitizeStringArray(payload.purchasedHandles, 100, 255),
    );
    return { interactions, purchasedHandles };
  };

  const loadRemoteProfile = async (root, signal) => {
    if (!behaviorTrackingAllowed() || !remoteSyncEnabled(root)) {
      return { interactions: [], purchasedHandles: new Set() };
    }
    const base = remoteProfileBase(root);
    if (!base) return { interactions: [], purchasedHandles: new Set() };
    const visitorId = getVisitorId();
    const cacheKey = `${base}|${visitorId}`;
    const existing = remoteProfileRequests.get(cacheKey);
    if (existing && Date.now() - existing.timestamp < REMOTE_PROFILE_CACHE_MS) {
      return awaitWithSignal(existing.promise, signal);
    }
    const url = `${base}/profile?visitor_id=${encodeURIComponent(visitorId)}`;
    const promise = fetchJson(
      url,
      { credentials: 'same-origin', headers: { Accept: 'application/json' } },
      REQUEST_TIMEOUT_MS,
    )
      .then(sanitizeRemoteProfile)
      .catch(() => ({ interactions: [], purchasedHandles: new Set() }));
    remoteProfileRequests.set(cacheKey, { promise, timestamp: Date.now() });
    return awaitWithSignal(promise, signal);
  };

  const sanitizeCartMeta = (item, now = Date.now()) => {
    if (!item || typeof item !== 'object') return null;
    const variantId = normalizeId(item.variantId);
    const timestamp = Number(item.timestamp);
    if (!variantId || !Number.isFinite(timestamp) || now - timestamp > CART_META_TTL_MS) {
      return null;
    }

    return {
      variantId,
      productId: normalizeId(item.productId),
      handle: boundedString(item.handle, 255),
      title: boundedString(item.title, 500),
      type: boundedString(item.type, 250),
      vendor: boundedString(item.vendor, 250),
      tags: boundedString(item.tags, 2_000),
      category: boundedString(item.category, 500),
      collections: boundedString(item.collections, 2_000),
      keywords: boundedString(item.keywords, 2_000),
      url: boundedString(item.url, 1_000),
      timestamp,
    };
  };

  const readCartMetaCache = () => {
    try {
      const parsed = safeJsonParse(sessionStorage.getItem(CART_META_STORAGE_KEY), []);
      if (!Array.isArray(parsed)) return new Map();
      const now = Date.now();
      const sanitized = parsed.map((item) => sanitizeCartMeta(item, now)).filter(Boolean);
      if (sanitized.length !== parsed.length) {
        sessionStorage.setItem(CART_META_STORAGE_KEY, JSON.stringify(sanitized));
      }
      return new Map(sanitized.map((item) => [item.variantId, item]));
    } catch (_error) {
      return new Map();
    }
  };

  const writeCartMetaCache = (items) => {
    try {
      const now = Date.now();
      const cache = readCartMetaCache();
      items.forEach((item) => {
        if (!item.variantId) return;
        cache.set(item.variantId, {
          variantId: item.variantId,
          productId: item.productId || '',
          handle: item.handle || '',
          title: item.title || '',
          type: item.type || '',
          vendor: item.vendor || '',
          tags: item.tags || '',
          category: item.category || '',
          collections: item.collections || '',
          keywords: item.keywords || '',
          url: item.url || '',
          timestamp: now,
        });
      });
      sessionStorage.setItem(
        CART_META_STORAGE_KEY,
        JSON.stringify([...cache.values()].slice(-100)),
      );
    } catch (_error) {
      // Session storage is an optimization only.
    }
  };

  const clearCartMetaCache = () => {
    try {
      sessionStorage.removeItem(CART_META_STORAGE_KEY);
    } catch (_error) {
      // Best effort.
    }
  };

  const normalizeAjaxCartItems = (ajaxCart) =>
    (Array.isArray(ajaxCart?.items) ? ajaxCart.items : [])
      .map((item) => ({
        handle: boundedString(item.handle, 255),
        productId: normalizeId(item.product_id || item.productId),
        title: boundedString(item.product_title || item.title, 500),
        type: boundedString(item.product_type, 250),
        vendor: boundedString(item.vendor, 250),
        tags: Array.isArray(item.tags)
          ? boundedString(item.tags.join('||'), 2_000)
          : boundedString(item.tags, 2_000),
        category: '',
        collections: '',
        keywords: '',
        url: boundedString(item.url, 1_000),
        variantId: normalizeId(item.variant_id || item.id),
        quantity: Math.max(0, numeric(item.quantity)),
      }))
      .filter((item) => item.handle || item.variantId);

  const standardCartLines = (summary) => {
    if (Array.isArray(summary?.lines)) return summary.lines;
    if (Array.isArray(summary?.lines?.nodes)) return summary.lines.nodes;
    if (Array.isArray(summary?.lines?.edges)) {
      return summary.lines.edges.map((edge) => edge?.node).filter(Boolean);
    }
    return [];
  };

  const normalizeStandardCartLines = (summary) =>
    standardCartLines(summary)
      .map((line) => ({
        variantId: normalizeId(
          line?.merchandiseId || line?.merchandise?.id || line?.variantId,
        ),
        productId: normalizeId(
          line?.productId || line?.merchandise?.product?.id || line?.merchandise?.productId,
        ),
        quantity: Math.max(0, numeric(line?.quantity)),
      }))
      .filter((line) => line.variantId && line.quantity > 0);

  const cachedItemsForSummary = (summary) => {
    const lines = normalizeStandardCartLines(summary);
    if (!lines.length) return null;
    const cache = readCartMetaCache();
    const items = [];

    for (const line of lines) {
      const metadata = cache.get(line.variantId);
      if (!metadata) return null;
      items.push({ ...metadata, quantity: line.quantity });
    }
    return items;
  };

  const getStandardCart = async (signal) => {
    if (typeof window.Shopify?.actions?.getCart !== 'function') return null;

    const controller = new AbortController();
    const timeout = window.setTimeout(
      () => controller.abort(createAbortError()),
      REQUEST_TIMEOUT_MS,
    );
    const abort = () => controller.abort(signal.reason || createAbortError());

    if (signal) {
      if (signal.aborted) abort();
      else signal.addEventListener('abort', abort, { once: true });
    }

    try {
      const result = await window.Shopify.actions.getCart(undefined, {
        signal: controller.signal,
      });
      return result?.cart || null;
    } finally {
      window.clearTimeout(timeout);
      signal?.removeEventListener('abort', abort);
    }
  };

  const requestAjaxCart = () => {
    if (ajaxCartRequest) return ajaxCartRequest;
    const root = window.Shopify?.routes?.root || '/';
    const cartUrl = `${root.endsWith('/')?root:`${root}/`}cart.js`;ajaxCartRequest=fetchJson(cartUrl,{credentials:'same-origin',headers:{Accept:'application/json'},},REQUEST_TIMEOUT_MS,).finally(()=>{ajaxCartRequest=null;});return ajaxCartRequest;};const recordMetricForRoots=(eventName,product={})=>{document.querySelectorAll(ROOT_SELECTOR).forEach((root)=>{if(root.dataset.personalization==='true')recordMetric(root,eventName,product);});};const persistRecentCartInteractions=(items)=>{const itemsByVariant=new Map((Array.isArray(items)?items:[]).filter((item)=>item.variantId).map((item)=>[item.variantId,item]),);recentVariantSignals.forEach((_timestamp,variantId)=>{const item=itemsByVariant.get(variantId);if(!item)return;recordInteraction('add',item);recordFatigueAction(item,'add');recordMetricForRoots('add',item);recentVariantSignals.delete(variantId);});};const observeCartChanges=(items)=>{const next=new Map((Array.isArray(items)?items:[]).filter((item)=>item.variantId).map((item)=>[item.variantId,{...item,quantity:Math.max(0,numeric(item.quantity))}]),);if(previousCartItems){previousCartItems.forEach((previous,variantId)=>{const nextQuantity=numeric(next.get(variantId)?.quantity);if(nextQuantity>=numeric(previous.quantity))return;recordInteraction('remove',previous);sendRemoteEvent(document.querySelector(ROOT_SELECTOR),'remove',previous);});}previousCartItems=next;};const getCartContext=async({force=false,signal,summaryHint=undefined}={})=>{const now=Date.now();if(!force&&Array.isArray(cartCache.items)&&now-cartCache.timestamp<CART_CACHE_MS){return cartCache;}let summary=summaryHint!==undefined?summaryHint:cartCache.summary;if(summaryHint===undefined&&(force||!summary||now-cartCache.timestamp>=CART_CACHE_MS)){try{summary=await getStandardCart(signal);}catch(error){if(error?.name==='AbortError')throw error;summary=null;}}if(summary&&numeric(summary.totalQuantity)===0){clearCartMetaCache();observeCartChanges([]);cartCache={summary,items:[],timestamp:Date.now()};return cartCache;}const cachedItems=summary?cachedItemsForSummary(summary):null;if(cachedItems){persistRecentCartInteractions(cachedItems);observeCartChanges(cachedItems);cartCache={summary,items:cachedItems,timestamp:Date.now()};return cartCache;}let ajaxCart=null;try{ajaxCart=await awaitWithSignal(requestAjaxCart(),signal);}catch(error){if(error?.name==='AbortError')throw error;}const items=normalizeAjaxCartItems(ajaxCart);if(items.length)writeCartMetaCache(items);persistRecentCartInteractions(items);observeCartChanges(items);if(!summary&&ajaxCart){summary={id:ajaxCart.token||null,totalQuantity:numeric(ajaxCart.item_count),lines:[],};}cartCache={summary:summary||null,items,timestamp:Date.now()};return cartCache;};const primeCartSummary=(summary)=>{cartCache={summary:summary||null,items:summary&&numeric(summary.totalQuantity)===0?[]:null,timestamp:Date.now(),};};const invalidateCart=()=>{cartCache={summary:null,items:null,timestamp:0};};const pruneRecentVariantSignals=()=>{const cutoff=Date.now()-RECENT_CART_SIGNAL_TTL_MS;recentVariantSignals.forEach((timestamp,variantId)=>{if(timestamp<cutoff)recentVariantSignals.delete(variantId);});};const recordRecentCartLines=(lines)=>{const now=Date.now();(Array.isArray(lines)?lines:[]).forEach((line)=>{const variantId=normalizeId(line?.merchandiseId||line?.merchandise?.id);if(variantId)recentVariantSignals.set(variantId,now);});pruneRecentVariantSignals();};const getProductHandleFromPath=(pathname)=>{const match=String(pathname||'').match(/(?:^|\/)products\/([^/?#]+)/u);if(!match)return'';try{return decodeURIComponent(match[1]);}catch(_error){return match[1];}};const getReferrerHandle=()=>{if(!document.referrer)return'';try{const referrer=new URL(document.referrer);if(referrer.origin!==window.location.origin)return'';return getProductHandleFromPath(referrer.pathname);}catch(_error){return'';}};const productFromAjaxResponse=(product,fallbackHandle='')=>({handle:product?.handle||fallbackHandle,productId:normalizeId(product?.id||product?.product_id),variantId:normalizeId(product?.selected_or_first_available_variant?.id||product?.variants?.find?.((variant)=>variant?.available)?.id||product?.variants?.[0]?.id,),title:product?.title||'',type:product?.type||product?.product_type||'',vendor:product?.vendor||'',tags:Array.isArray(product?.tags)?product.tags.join('||'):product?.tags||'',category:product?.category?.name||product?.category||'',collections:Array.isArray(product?.collections)?product.collections.map((collection)=>collection?.handle||collection?.title||collection).join(' '):product?.collections||'',keywords:product?.keywords||'',url:product?.url||`/products/${fallbackHandle}`,
  });

  const readEmbeddedProductContext = () => {
    const script = document.getElementById('z2fc-product-context');
    if (!script?.textContent) return null;
    const parsed = safeJsonParse(script.textContent, null);
    if (!parsed || typeof parsed !== 'object') return null;
    return {
      handle: parsed.handle || getProductHandleFromPath(window.location.pathname),
      productId: parsed.productId || parsed.id || '',
      variantId: parsed.variantId || '',
      title: parsed.title || '',
      type: parsed.type || parsed.productType || '',
      vendor: parsed.vendor || '',
      tags: Array.isArray(parsed.tags) ? parsed.tags.join('||') : parsed.tags || '',
      category: parsed.category || parsed.taxonomyCategory || '',
      collections: Array.isArray(parsed.collections) ? parsed.collections.join(' ') : parsed.collections || '',
      keywords: Array.isArray(parsed.keywords) ? parsed.keywords.join(' ') : parsed.keywords || '',
      url: parsed.url || window.location.pathname,
    };
  };

  const fetchAndRecordProduct = (handle) => {
    if (!handle || recordedReferrerHandles.has(handle)) return Promise.resolve(false);
    if (referrerRequests.has(handle)) return referrerRequests.get(handle);

    const shopRoot = window.Shopify?.routes?.root || '/';
    const base = shopRoot.endsWith('/') ? shopRoot : `${shopRoot}/`;
    const request = fetchJson(
      `${base}products/${encodeURIComponent(handle)}.js`,
      {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      },
      REQUEST_TIMEOUT_MS,
    )
      .then((product) => {
        const recorded = recordInteraction('view', productFromAjaxResponse(product, handle));
        if (recorded) recordedReferrerHandles.add(handle);
        return recorded;
      })
      .catch(() => false)
      .finally(() => referrerRequests.delete(handle));

    referrerRequests.set(handle, request);
    return request;
  };

  const fetchReferrerProduct = (handle) => fetchAndRecordProduct(handle);

  const trackCurrentProductPage = () => {
    const embedded = readEmbeddedProductContext();
    const handle = embedded?.handle || getProductHandleFromPath(window.location.pathname);
    if (!handle || recordedCurrentPageHandles.has(handle)) return Promise.resolve(false);
    recordedCurrentPageHandles.add(handle);

    if (embedded?.title || embedded?.productId || embedded?.tokens?.length) {
      const recorded = recordInteraction('view', embedded);
      if (recorded) {
        sendRemoteEvent(document.querySelector(ROOT_SELECTOR), 'view', embedded);
        return Promise.resolve(true);
      }
    }

    return fetchAndRecordProduct(handle).then((recorded) => {
      if (!recorded) recordedCurrentPageHandles.delete(handle);
      return recorded;
    });
  };

  const candidatePrototype = (source) => {
    if (!source) return null;
    if (source.tagName !== 'TEMPLATE') return source;
    return (
      source.content.querySelector?.('[data-z2fc-candidate-data]') ||
      source.content.firstElementChild
    );
  };

  const createCandidate = (source, index, renderPrototype = null) => {
    const prototype = candidatePrototype(source);
    const isCard = prototype?.matches?.(CARD_SELECTOR);
    const isCompactData = prototype?.matches?.('[data-z2fc-candidate-data]');
    if (!isCard && !isCompactData) return null;
    return {
      source,
      prototype,
      renderPrototype: isCard ? prototype : renderPrototype,
      card: isCard && source.tagName !== 'TEMPLATE' ? source : null,
      index,
      tokens: null,
      score: null,
    };
  };

  const strictGateDataApproved = (data, gate) => {
    if (!data || !gate || gate === 'any' || gate === 'deals') return true;
    const liquidApproved =
      data.liquidCategoryApproved === 'true' &&
      data.liquidResolvedCategory === gate;
    const dynamicApproved =
      data.dynamicCategoryApproved === 'true' &&
      data.resolvedCategory === gate;
    return liquidApproved || dynamicApproved;
  };

  const purgeInvalidStrictColumnCards = (root) => {
    root.querySelectorAll(COLUMN_SELECTOR).forEach((column, columnIndex) => {
      const profileName = column.dataset.profile || 'collection';
      const gate =
        column.dataset.categoryGate ||
        (columnIndex === 0
          ? 'deals'
          : PROFILE_CATEGORY_GATES[profileName] || 'any');

      if (gate === 'any' || gate === 'deals') return;

      column.querySelectorAll(CARD_SELECTOR).forEach((card) => {
        if (!strictGateDataApproved(card.dataset, gate)) card.remove();
      });

      column.querySelectorAll(TEMPLATE_SELECTOR).forEach((template) => {
        const dataNode = candidatePrototype(template);
        if (!strictGateDataApproved(dataNode?.dataset, gate)) template.remove();
      });
    });
  };

  const collectColumns = (root) =>
    [...root.querySelectorAll(COLUMN_SELECTOR)].map((column, columnIndex) => {
      const grid = column.querySelector('[data-z2fc-product-grid]');
      const sources = grid
        ? [...grid.children].filter(
            (child) => child.matches?.(CARD_SELECTOR) || child.matches?.(TEMPLATE_SELECTOR),
          )
        : [];
      const renderPrototype =
        sources.find((source) => source.matches?.(CARD_SELECTOR)) || null;
      const candidates = sources
        .map((source, index) => createCandidate(source, index, renderPrototype))
        .filter(Boolean);
      const profileName = column.dataset.profile || 'collection';
      const categoryGate = column.dataset.categoryGate ||
        (columnIndex === 0 ? 'deals' : PROFILE_CATEGORY_GATES[profileName] || 'any');
      return {
        column,
        columnIndex,
        grid,
        candidates,
        renderPrototype,
        imageSizesHalf: column.dataset.productSizesHalf || '',
        imageSizesFull: column.dataset.productSizesFull || '',
        displayCount: Math.max(1, numeric(column.dataset.displayCount) || 4),
        profileName,
        categoryGate,
        profileTerms: new Set([
          ...(PROFILE_TERMS[column.dataset.profile || 'collection'] || PROFILE_TERMS.collection),
          ...tokenize(column.dataset.profileKeywords || ''),
          ...tokenize(column.dataset.profileCollectionTerms || ''),
        ]),
      };
    });

  const candidateDataset = (candidate) => candidate.prototype.dataset;
  const candidateHandle = (candidate) => candidateDataset(candidate).productHandle || '';
  const candidateVariantId = (candidate) => normalizeId(candidateDataset(candidate).variantId);
  const candidateProductId = (candidate) => normalizeId(candidateDataset(candidate).productId);
  const candidateManualMode = (candidate) => candidateDataset(candidate).manualMode || 'none';
  const candidateSource = (candidate) => candidateDataset(candidate).candidateSource ||
    (candidateDataset(candidate).nativeRecommendation === 'true' ? 'native' : 'unknown');
  const candidateInCart = (candidate, profile) =>
    profile.cartHandles.has(candidateHandle(candidate)) ||
    profile.cartVariantIds.has(candidateVariantId(candidate));

  const copyCandidateDatasetToCard = (candidate, card) => {
    const data = candidateDataset(candidate);
    Object.entries(data).forEach(([key, value]) => {
      if (key.startsWith('z2fc')) return;
      card.dataset[key] = value;
    });
  };

  const renderCandidateCard = (candidate, card) => {
    if (!candidate || !card) return null;
    const data = candidateDataset(candidate);
    copyCandidateDatasetToCard(candidate, card);

    const title = data.productTitle || '';
    const link = card.querySelector(LINK_SELECTOR);
    if (link) {
      link.href = data.productUrl || '#';
      link.setAttribute('aria-label', data.z2fcAriaLabel || title);
    }

    const titleElement = card.querySelector('.z2fc__product-title');
    if (titleElement) {
      titleElement.textContent = title;
      titleElement.title = title;
    }

    const image = card.querySelector(PRODUCT_IMAGE_SELECTOR);
    const imageWrapper = image?.closest?.('.z2fc__product-image');
    const imageSrc = data.z2fcImageSrc || '';
    if (image) {
      initializedImages.delete(image);
      delete image.dataset.z2fcHydrated;
      delete image.dataset.z2fcServerRendered;
      image.removeAttribute('src');
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');

      image.dataset.z2fcSrc = imageSrc;
      image.dataset.z2fcSrcset = data.z2fcImageSrcset || '';
      image.dataset.z2fcSizes = data.z2fcImageSizes || '';
      image.dataset.z2fcImagePriority = data.z2fcImagePriority || 'auto';
      image.alt = data.z2fcImageAlt || title;
      image.loading = 'lazy';
      if ('fetchPriority' in image) image.fetchPriority = 'auto';
      image.decoding = 'async';

      const imageWidth = Math.floor(numeric(data.z2fcImageWidth));
      const imageHeight = Math.floor(numeric(data.z2fcImageHeight));
      if (imageWidth > 0) image.width = imageWidth;
      else image.removeAttribute('width');
      if (imageHeight > 0) image.height = imageHeight;
      else image.removeAttribute('height');
    }

    if (imageWrapper) {
      imageWrapper.classList.remove('is-loaded', 'has-error');
      imageWrapper.classList.toggle('is-loading', Boolean(imageSrc));
      imageWrapper.classList.toggle('has-error', !imageSrc);
    }

    const isFirstColumnCard = Boolean(card.querySelector('.z2fc__deal-overlay'));
    const available = data.available !== 'false';
    let soldOut = card.querySelector('.z2fc__sold-out-badge');
    if (!available && !soldOut && !isFirstColumnCard) {
      soldOut = document.createElement('span');
      soldOut.className = 'z2fc__sold-out-badge';
      imageWrapper?.append(soldOut);
    }
    if (soldOut) {
      if (available || isFirstColumnCard) {
        soldOut.remove();
      } else {
        soldOut.textContent = data.z2fcSoldOutLabel || 'Sold out';
      }
    }

    const deal = card.querySelector('.z2fc__deal-percent');
    if (deal && data.z2fcDealText) deal.textContent = data.z2fcDealText;
    const limited = card.querySelector('.z2fc__limited-deal');
    if (limited && data.z2fcLimitedLabel) limited.textContent = data.z2fcLimitedLabel;

    const price = numeric(data.price);
    const comparePrice = numeric(data.comparePrice);
    const discountPercent = Math.max(
      0,
      Math.floor(
        numeric(data.discountPercent) ||
        (comparePrice > price && comparePrice > 0 ? ((comparePrice - price) * 100) / comparePrice : 0),
      ),
    );

    const priceElement = card.querySelector('.z2fc__reference-price');
    if (priceElement) priceElement.textContent = z2fcFormatMoney(price);

    const savings = Math.max(0, comparePrice - price);
    const saveElement = card.querySelector('.z2fc__reference-save');
    if (saveElement) {
      saveElement.hidden = savings <= 0;
      saveElement.textContent = savings > 0 ? `Save ${z2fcFormatMoney(savings)}` : '';
    }

    const discountElement = card.querySelector('.z2fc__reference-discount');
    if (discountElement) {
      discountElement.hidden = discountPercent <= 0;
      discountElement.textContent = `-${discountPercent}%`;
    }

    const compareElement = card.querySelector('.z2fc__reference-compare');
    if (compareElement) {
      compareElement.hidden = !(comparePrice > price && price > 0);
      compareElement.textContent = comparePrice > price ? z2fcFormatMoney(comparePrice) : '';
    }

    const priceDropBadge = card.querySelector('.z2fc__price-drop-badge');
    if (priceDropBadge) priceDropBadge.hidden = true;

    const rating = Math.max(0, Math.min(5, numeric(data.rating)));
    const ratingCount = Math.max(0, Math.floor(numeric(data.ratingCount)));
    const reviews = card.querySelector('.z2fc__reference-reviews');
    if (reviews) {
      reviews.hidden = rating <= 0;
      const ratingElement = reviews.querySelector('.z2fc__reference-rating');
      const countElement = reviews.querySelector('.z2fc__reference-review-count');
      if (ratingElement) ratingElement.textContent = rating.toFixed(1);
      if (countElement) countElement.textContent = String(ratingCount);
    }

    return card;
  };

  const updatePriceDropBadges = (root) => {
    root.querySelectorAll(COLUMN_SELECTOR).forEach((column) => {
      const cards = [...column.querySelectorAll(CARD_SELECTOR)].filter(
        (card) => card.isConnected && !card.hidden,
      );

      const ranked = cards
        .map((card, index) => ({
          card,
          index,
          discount: Math.max(0, Math.floor(numeric(card.dataset.discountPercent))),
          rating: Math.max(0, Math.min(5, numeric(card.dataset.rating))),
          ratingCount: Math.max(0, Math.floor(numeric(card.dataset.ratingCount))),
        }))
        .filter((entry) => entry.discount > 0)
        .sort((left, right) =>
          right.discount - left.discount ||
          right.rating - left.rating ||
          right.ratingCount - left.ratingCount ||
          left.index - right.index
        );

      /* Conversion-focused scarcity:
         show the PRICE DROP graphic on only the two strongest
         discounted products in each column. */
      const keep = new Set(ranked.slice(0, 2).map((entry) => entry.card));

      cards.forEach((card) => {
        const badge = card.querySelector('.z2fc__price-drop-badge');
        if (!badge) return;
        badge.hidden = !keep.has(card);
      });
    });
  };

  const materializeCandidate = (candidate) => {
    if (candidate.card) return candidate.card;

    let clone = null;
    if (candidate.prototype?.matches?.(CARD_SELECTOR)) {
      clone = candidate.prototype.cloneNode(true);
    } else if (candidate.renderPrototype?.matches?.(CARD_SELECTOR)) {
      clone = candidate.renderPrototype.cloneNode(true);
      renderCandidateCard(candidate, clone);
    }

    if (!clone) return null;
    candidate.card = clone;
    return clone;
  };

  const candidateTokens = (candidate) => {
    if (candidate.tokens) return candidate.tokens;
    const data = candidateDataset(candidate);
    const fields = {
      title: tokenize(data.productTitle),
      type: tokenize(data.productType),
      vendor: tokenize(data.productVendor),
      tags: tokenize(String(data.productTags || '').replaceAll('||', ' ')),
      category: tokenize(`${data.productCategory||''}${data.productCategoryId||''}`),
      collections: tokenize(data.productCollections),
      keywords: tokenize(data.productKeywords),
    };
    fields.all = [...new Set([
      ...fields.title,
      ...fields.type,
      ...fields.vendor,
      ...fields.tags,
      ...fields.category,
      ...fields.collections,
      ...fields.keywords,
    ])];
    candidate.tokens = fields;
    return fields;
  };

  const CATEGORY_FIELD_WEIGHTS = {
    title: 2,
    type: 3.5,
    vendor: 0.25,
    tags: 3,
    category: 7,
    collections: 7,
    keywords: 7,
  };

  /*
   * Strict gates use product-level evidence only. Collection membership is
   * excluded because a mixed collection can contain products from other
   * categories.
   */
  const STRICT_CATEGORY_FIELD_WEIGHTS = {
    title: 3,
    type: 5,
    vendor: 0,
    tags: 5,
    category: 9,
    collections: 0,
    keywords: 9,
  };

  const STRICT_CATEGORY_MIN_SCORE = {
    tech: 3,
    health_beauty: 3,
    car: 3,
  };

  const STRICT_CATEGORY_CONFLICT_TERMS = {
    tech: new Set(tokenize(
      'toy toys fidget sensory plush cartoon costume pajama pajamas onesie slipper slippers ' +
      'keychain novelty doll dolls figurine squishy slime puppet stuffed animal anime cosplay',
    )),
    health_beauty: new Set(tokenize(
      'dashcam dashboard obd windshield license plate jump starter carplay steering wheel',
    )),
    car: new Set(tokenize(
      'skincare makeup cosmetic cosmetics facial nail nails pajama onesie slipper plush fidget',
    )),
  };

  const categoryFieldsFromData = (data = {}) => {
    const fields = {
      title: tokenize(data.title || data.productTitle),
      type: tokenize(data.type || data.productType),
      vendor: tokenize(data.vendor || data.productVendor),
      tags: tokenize(String(data.tags || data.productTags || '').replaceAll('||', ' ')),
      category: tokenize(`${data.category||data.productCategory||''}${data.categoryId||data.productCategoryId||''}`),
      collections: tokenize(data.collections || data.productCollections),
      keywords: tokenize(data.keywords || data.productKeywords),
    };
    fields.all = [...new Set(Object.values(fields).flat())];
    return fields;
  };

  const categoryScoresFromFields = (
    fields,
    weights = CATEGORY_FIELD_WEIGHTS,
  ) => {
    const scores = { tech: 0, health_beauty: 0, car: 0 };
    Object.entries(CATEGORY_SIGNAL_TERMS).forEach(([category, terms]) => {
      Object.entries(weights).forEach(([field, weight]) => {
        if (!weight) return;
        const matches = (fields[field] || []).filter((token) => terms.has(token)).length;
        scores[category] += matches * weight;
      });
    });
    return scores;
  };

  const classifyCategoryFields = (fields) => {
    const scores = categoryScoresFromFields(fields);
    const ranked = Object.entries(scores)
      .map(([category, score]) => ({ category, score }))
      .sort((left, right) => right.score - left.score);
    const top = ranked[0] || { category: 'unknown', score: 0 };
    const second = ranked[1] || { category: 'unknown', score: 0 };
    const car = scores.car || 0;
    const health = scores.health_beauty || 0;
    const tech = scores.tech || 0;

    let category = 'unknown';
    if (car >= 7 && car >= health && car >= tech * 0.72) {
      category = 'car';
    } else if (health >= 7 && health >= car && health >= tech * 0.72) {
      category = 'health_beauty';
    } else if (tech >= 5 && tech > car * 1.08 && tech > health * 1.08) {
      category = 'tech';
    } else if (top.score >= 10 && top.score >= second.score + 2) {
      category = top.category;
    }

    return {
      category,
      scores,
      topScore: top.score,
      secondScore: second.score,
      confident: category !== 'unknown',
    };
  };

  const classifyCategoryData = (data = {}) =>
    classifyCategoryFields(categoryFieldsFromData(data));

  const productLevelCategoryFields = (fields) => ({
    title: fields.title || [],
    type: fields.type || [],
    vendor: [],
    tags: fields.tags || [],
    category: fields.category || [],
    collections: [],
    keywords: fields.keywords || [],
    all: [
      ...(fields.title || []),
      ...(fields.type || []),
      ...(fields.tags || []),
      ...(fields.category || []),
      ...(fields.keywords || []),
    ],
  });

  const classifyStrictCategoryFields = (fields) => {
    const intrinsicFields = productLevelCategoryFields(fields);
    const scores = categoryScoresFromFields(
      intrinsicFields,
      STRICT_CATEGORY_FIELD_WEIGHTS,
    );
    const ranked = Object.entries(scores)
      .map(([category, score]) => ({ category, score }))
      .sort((left, right) => right.score - left.score);

    const top = ranked[0] || { category: 'unknown', score: 0 };
    const second = ranked[1] || { category: 'unknown', score: 0 };
    const conflicts = Object.fromEntries(
      Object.entries(STRICT_CATEGORY_CONFLICT_TERMS).map(([category, terms]) => [
        category,
        intrinsicFields.all.filter((token) => terms.has(token)).length,
      ]),
    );

    const minimum = STRICT_CATEGORY_MIN_SCORE[top.category] || Infinity;
    const hasEnoughEvidence = top.score >= minimum;
    const beatsCompetingCategory =
      top.score >= second.score + 1 ||
      (top.score >= 9 && top.score >= second.score);
    const hasHardConflict =
      top.category !== 'unknown' &&
      (conflicts[top.category] || 0) > 0 &&
      top.score < 9;

    const category =
      hasEnoughEvidence && beatsCompetingCategory && !hasHardConflict
        ? top.category
        : 'unknown';

    return {
      category,
      scores,
      conflicts,
      topScore: top.score,
      secondScore: second.score,
      confident: category !== 'unknown',
    };
  };

  const classifyStrictCategoryData = (data = {}) =>
    classifyStrictCategoryFields(categoryFieldsFromData(data));

  const liquidAuthoritativeClassification = (candidate) => {
    const data = candidateDataset(candidate);
    const category = data.liquidResolvedCategory || '';
    if (
      data.liquidCategoryApproved === 'true' &&
      ['tech', 'health_beauty', 'car'].includes(category)
    ) {
      return {
        category,
        scores: { tech: 0, health_beauty: 0, car: 0 },
        conflicts: {},
        topScore: Infinity,
        secondScore: 0,
        confident: true,
        source: 'liquid',
      };
    }
    return null;
  };

  const classifyCandidateCategory = (candidate) => {
    if (candidate.categoryClassification) return candidate.categoryClassification;
    candidate.categoryClassification =
      liquidAuthoritativeClassification(candidate) ||
      classifyCategoryFields(candidateTokens(candidate));
    return candidate.categoryClassification;
  };

  const classifyCandidateStrictCategory = (candidate) => {
    if (candidate.strictCategoryClassification) {
      return candidate.strictCategoryClassification;
    }
    candidate.strictCategoryClassification =
      liquidAuthoritativeClassification(candidate) ||
      classifyStrictCategoryFields(candidateTokens(candidate));
    return candidate.strictCategoryClassification;
  };

  const categoryGateAllowsCandidate = (candidate, entry) => {
    const gate = entry.categoryGate || 'any';
    if (gate === 'any') return true;

    const source = candidateSource(candidate);
    const data = candidateDataset(candidate);
    const native =
      data.nativeRecommendation === 'true' ||
      source === 'native';

    if (gate === 'deals') {
      const broadClassification = classifyCandidateCategory(candidate);
      if (TRUSTED_CURATED_SOURCES.has(source) && !native) return true;
      return APPROVED_DEAL_CATEGORIES.has(broadClassification.category);
    }

    if (
      data.liquidCategoryApproved === 'true' &&
      data.liquidResolvedCategory === gate
    ) {
      return true;
    }

    return (
      native &&
      data.dynamicCategoryApproved === 'true' &&
      data.resolvedCategory === gate
    );
  };

  const readNativeCache = () => {
    try {
      const parsed = safeJsonParse(sessionStorage.getItem(NATIVE_CACHE_STORAGE_KEY), {});
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (_error) {
      return {};
    }
  };

  const writeNativeCache = (cache) => {
    try {
      const now = Date.now();
      const compact = Object.fromEntries(
        Object.entries(cache)
          .filter(([, value]) => now - numeric(value?.timestamp) <= NATIVE_CACHE_TTL_MS)
          .slice(-20),
      );
      sessionStorage.setItem(NATIVE_CACHE_STORAGE_KEY, JSON.stringify(compact));
    } catch (_error) {
      // Session cache is optional.
    }
  };



  const candidateMetadata = (candidate) => {
    const data = candidateDataset(candidate);
    return {
      handle: candidateHandle(candidate),
      productId: candidateProductId(candidate),
      variantId: candidateVariantId(candidate),
      title: data.productTitle || '',
      type: data.productType || '',
      vendor: data.productVendor || '',
      tags: data.productTags || '',
      category: data.productCategory || '',
      categoryId: data.productCategoryId || '',
      collections: data.productCollections || '',
      keywords: data.productKeywords || '',
      url: data.productUrl || '',
    };
  };

  const buildExistingMetadataIndex = (state) => {
    const index = new Map();
    state.columns.forEach((entry) => {
      entry.candidates.forEach((candidate) => {
        const metadata = candidateMetadata(candidate);
        if (!metadata.handle) return;
        const current = index.get(metadata.handle);
        const richness = ['category', 'collections', 'keywords', 'tags', 'type']
          .reduce((sum, key) => sum + (metadata[key] ? 1 : 0), 0);
        const currentRichness = current
          ? ['category', 'collections', 'keywords', 'tags', 'type']
              .reduce((sum, key) => sum + (current[key] ? 1 : 0), 0)
          : -1;
        if (!current || richness > currentRichness) index.set(metadata.handle, metadata);
      });
    });
    return index;
  };

  const mergeNativeMetadata = (product, metadata = {}) => ({
    handle: metadata.handle || product?.handle || '',
    productId: metadata.productId || normalizeId(product?.id),
    variantId: metadata.variantId || '',
    title: metadata.title || product?.title || '',
    type: metadata.type || product?.type || '',
    vendor: metadata.vendor || product?.vendor || '',
    tags: metadata.tags || (Array.isArray(product?.tags) ? product.tags.join('||') : product?.tags || ''),
    category: metadata.category || '',
    categoryId: metadata.categoryId || '',
    collections: metadata.collections || '',
    keywords: metadata.keywords || '',
    url: metadata.url || product?.url || '',
  });



  const storefrontRecommendationContextKey = () => {
    const shopRoot = window.Shopify?.routes?.root || '/';
    const locale =
      window.Shopify?.locale ||
      document.documentElement?.lang ||
      '';
    const country = window.Shopify?.country || '';
    const currency = window.Shopify?.currency?.active || '';
    return [
      window.location.origin,
      shopRoot,
      locale,
      country,
      currency,
    ].map((value) => String(value || '')).join('|');
  };

  const fetchNativeRecommendations = async (productId, limit, signal) => {
    const normalizedId = normalizeId(productId);
    if (!normalizedId) return [];
    const boundedLimit = Math.max(1, Math.min(10, Math.floor(numeric(limit) || 10)));
    const contextKey = storefrontRecommendationContextKey();
    const key = `${contextKey}|${normalizedId}|related|${boundedLimit}`;
    const cache = readNativeCache();
    const cached = cache[key];
    if (
      cached &&
      Date.now() - numeric(cached.timestamp) <= NATIVE_CACHE_TTL_MS &&
      Array.isArray(cached.products)
    ) {
      return cached.products;
    }
    if (nativeRecommendationRequests.has(key)) {
      return awaitWithSignal(nativeRecommendationRequests.get(key), signal);
    }

    const shopRoot = window.Shopify?.routes?.root || '/';
    const base = shopRoot.endsWith('/') ? shopRoot : `${shopRoot}/`;
    const url = `${base}recommendations/products.json?product_id=${encodeURIComponent(normalizedId)}&limit=${boundedLimit}&intent=related`;
    const request = fetchJson(
      url,
      { credentials: 'same-origin', headers: { Accept: 'application/json' } },
      REQUEST_TIMEOUT_MS,
    )
      .then((payload) => (Array.isArray(payload?.products) ? payload.products : []))
      .then((products) => {
        const nextCache = readNativeCache();
        nextCache[key] = {
          timestamp: Date.now(),
          context: contextKey,
          products,
        };
        writeNativeCache(nextCache);
        return products;
      })
      .catch(() => [])
      .finally(() => nativeRecommendationRequests.delete(key));
    nativeRecommendationRequests.set(key, request);
    return awaitWithSignal(request, signal);
  };

  const nativeProductImageInfo = (product) => {
    const candidates = [
      product?.featured_image,
      product?.featured_media?.preview_image,
      Array.isArray(product?.images) ? product.images[0] : null,
    ].filter(Boolean);

    for (const candidate of candidates) {
      if (typeof candidate === 'string') {
        return { src: candidate, width: 0, height: 0 };
      }
      const src = candidate?.src || candidate?.url || '';
      if (src) {
        return {
          src,
          width: Math.max(0, Math.floor(numeric(candidate?.width))),
          height: Math.max(0, Math.floor(numeric(candidate?.height))),
        };
      }
    }
    return { src: '', width: 0, height: 0 };
  };

  const shopifyImageUrlAtWidth = (src, width) => {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (_error) {
      return `${src}${src.includes('?') ? '&' : '?'}width=${width}`;
    }
  };

  const nativeImageSrcset = (src) =>
    src
      ? [180, 240, 320, 420, 560, 700, 900]
          .map((width) => `${shopifyImageUrlAtWidth(src, width)} ${width}w`)
          .join(', ')
      : '';

  const createNativeCandidate = (
    entry,
    product,
    sourcePosition,
    metadata = {},
    classification = null,
  ) => {
    const handle = boundedString(product?.handle, 255).trim();
    if (!entry.renderPrototype || !handle || product?.available === false) return null;

    const productId = normalizeId(product?.id);
    const selectedVariant =
      product?.variants?.find?.((variant) => variant?.available) ||
      product?.variants?.[0] ||
      null;
    const variantId = normalizeId(selectedVariant?.id);
    const title = boundedString(product?.title, 500);
    const url = product?.url || `${window.Shopify?.routes?.root||'/'}products/${handle}`;
    const imageInfo = nativeProductImageInfo(product);
    const price = numeric(selectedVariant?.price || product?.price_min || product?.price);
    const comparePrice = numeric(
      selectedVariant?.compare_at_price ||
      product?.compare_at_price_min ||
      product?.compare_at_price,
    );
    const discount = comparePrice > price
      ? Math.max(1, Math.floor(((comparePrice - price) * 100) / comparePrice))
      : 0;
    const enriched = mergeNativeMetadata(product, metadata);
    const resolvedCategory =
      classification?.confident ? classification.category : 'unknown';
    const strictApproved =
      ['tech', 'health_beauty', 'car'].includes(resolvedCategory);
    const root = entry.column.closest(ROOT_SELECTOR);

    const carrier = document.createElement('span');
    carrier.setAttribute('data-z2fc-candidate-data', '');
    const data = carrier.dataset;

    data.productHandle = handle;
    data.productId = productId;
    data.variantId = variantId;
    data.price = String(price);
    data.comparePrice = String(comparePrice);
    data.discountPercent = String(discount);
    data.productTitle = title;
    data.productType = boundedString(enriched.type, 250);
    data.productVendor = boundedString(enriched.vendor, 250);
    data.productTags = boundedString(enriched.tags, 2_000);
    data.productCategory = boundedString(enriched.category, 500);
    data.productCategoryId = boundedString(enriched.categoryId, 250);
    data.productCollections = boundedString(enriched.collections, 2_000);
    data.productKeywords = boundedString(enriched.keywords, 2_000);
    data.productUrl = enriched.url || url;
    data.rating = '0';
    data.ratingCount = '0';
    data.popularity = String(Math.max(0, 120 - sourcePosition));
    data.sourcePosition = String(500 + sourcePosition);
    data.manualMode = 'none';
    data.candidateSource = 'native';
    data.originProfile = 'native';
    data.liquidCategoryApproved = 'false';
    data.liquidResolvedCategory = 'any';
    data.dynamicCategoryApproved = String(strictApproved);
    data.resolvedCategory = resolvedCategory;
    data.categorySource = 'js-native-strict';
    data.available = String(product?.available !== false);
    data.nativeRecommendation = 'true';

    data.z2fcAriaLabel = title;
    data.z2fcImageSrc = shopifyImageUrlAtWidth(imageInfo.src, 900);
    data.z2fcImageSrcset = nativeImageSrcset(imageInfo.src);
    data.z2fcImageSizes =
      entry.imageSizesHalf ||
      entry.renderPrototype.querySelector(PRODUCT_IMAGE_SELECTOR)?.sizes ||
      '';
    data.z2fcImageWidth = imageInfo.width ? String(imageInfo.width) : '';
    data.z2fcImageHeight = imageInfo.height ? String(imageInfo.height) : '';
    data.z2fcImageAlt = title;
    data.z2fcImagePriority = 'auto';
    data.z2fcDealText = discount
      ? `${discount}% off`
      : (root?.dataset.labelDeal || 'Deal');
    data.z2fcLimitedLabel =
      root?.dataset.labelLimitedDeal || 'Limited time deal';
    data.z2fcSoldOutLabel =
      root?.dataset.labelSoldOut || 'Sold out';

    const template = document.createElement('template');
    template.setAttribute('data-z2fc-candidate-template', '');
    template.dataset.z2fcNative = 'true';
    template.content.append(carrier);

    const candidate = createCandidate(
      template,
      entry.candidates.length + sourcePosition,
      entry.renderPrototype,
    );
    if (candidate) candidate.nativeRank = sourcePosition;
    return candidate;
  };

  const selectNativeSourceIds = (interactions, cartContext, sourceLimit) => {
    const scored = new Map();
    const now = Date.now();
    const add = (productId, score) => {
      const id = normalizeId(productId);
      if (!id) return;
      scored.set(id, Math.max(score, scored.get(id) || 0));
    };

    (cartContext?.items || []).forEach((item, index) => add(item.productId, 100 - index));
    interactions.forEach((item) => {
      const ageDays = Math.max(0, (now - item.lastInteraction) / 86_400_000);
      const recency = Math.pow(0.5, ageDays / 21);
      const score = recency * (
        Math.log1p(item.viewCount) * 5 +
        Math.log1p(item.addCount) * 16 +
        Math.log1p(item.sessionCount) * 8 +
        Math.log1p(item.engagementWeight) * 2
      );
      add(item.productId, score);
    });
    const embedded = readEmbeddedProductContext();
    if (embedded?.productId) add(embedded.productId, 80);

    return [...scored.entries()]
      .sort((left, right) => right[1] - left[1])
      .slice(0, Math.max(1, Math.min(3, Math.floor(numeric(sourceLimit) || 2))))
      .map(([id]) => id);
  };

  const enrichWithNativeRecommendations = async (
    root,
    state,
    interactions,
    cartContext,
    signal,
  ) => {
    if (root.dataset.nativeRecommendations !== 'true') return [];
    const sourceIds = selectNativeSourceIds(
      interactions,
      cartContext,
      root.dataset.nativeSourceLimit,
    );
    if (!sourceIds.length) return [];

    const limit = Math.max(
      1,
      Math.min(10, numeric(root.dataset.nativeRecommendationLimit) || 10),
    );
    const resultGroups = await Promise.all(
      sourceIds.map((productId) =>
        fetchNativeRecommendations(productId, limit, signal),
      ),
    );
    if (signal?.aborted) throw signal.reason || createAbortError();

    const uniqueProducts = [];
    const seen = new Set();
    resultGroups.flat().forEach((product) => {
      const handle = boundedString(product?.handle, 255).trim();
      if (!handle || seen.has(handle)) return;
      seen.add(handle);
      uniqueProducts.push(product);
    });

    const existingMetadata = buildExistingMetadataIndex(state);
    const enrichedProducts = uniqueProducts.map((product) => {
      const handle = boundedString(product?.handle, 255).trim();
      const metadata = existingMetadata.get(handle) || {};
      const mergedMetadata = mergeNativeMetadata(product, metadata);
      const classification = classifyStrictCategoryData(mergedMetadata);
      return { product, metadata, classification };
    });

    state.columns.forEach((entry) => {
      const existing = new Set(entry.candidates.map(candidateHandle));

      enrichedProducts.forEach(
        ({ product, metadata, classification }, index) => {
          const handle = boundedString(product?.handle, 255).trim();
          if (!handle || existing.has(handle)) return;

          if (
            entry.categoryGate !== 'any' &&
            entry.categoryGate !== 'deals' &&
            (
              !classification.confident ||
              classification.category !== entry.categoryGate
            )
          ) {
            return;
          }

          const candidate = createNativeCandidate(
            entry,
            product,
            index + 1,
            metadata,
            classification,
          );
          if (!candidate || !categoryGateAllowsCandidate(candidate, entry)) return;

          entry.candidates.push(candidate);
          existing.add(handle);
        },
      );
    });

    return enrichedProducts.map(({ product }) => product);
  };

  const buildInterestProfile = (
    state,
    interactions,
    cartContext,
    referrerHandle = '',
    remoteProfile = { interactions: [], purchasedHandles: new Set() },
  ) => {
    const weightedTokens = new Map();
    const categoryAffinity = new Map(Object.keys(PROFILE_TERMS).map((name) => [name, 0]));
    const negativeCategoryAffinity = new Map();
    const cartHandles = new Set();
    const cartVariantIds = new Set();
    const seenHandles = new Set();
    const purchasedHandles = new Set(remoteProfile?.purchasedHandles || []);
    const evidence = [];
    const fatigueByHandle = readFatigue();
    const now = Date.now();
    let signalStrength = 0;

    const allCandidates = state.columns.flatMap((entry) => entry.candidates);
    const candidatesByHandle = new Map();
    const candidatesByVariant = new Map();
    allCandidates.forEach((candidate) => {
      const handle = candidateHandle(candidate);
      const variantId = candidateVariantId(candidate);
      if (handle && !candidatesByHandle.has(handle)) candidatesByHandle.set(handle, candidate);
      if (variantId && !candidatesByVariant.has(variantId)) candidatesByVariant.set(variantId, candidate);
    });

    const addTokenList = (tokens, weight) => {
      if (!tokens.length || !Number.isFinite(weight) || weight === 0) return false;
      tokens.forEach((token) => {
        weightedTokens.set(token, (weightedTokens.get(token) || 0) + weight);
        Object.entries(PROFILE_TERMS).forEach(([profileName, terms]) => {
          if (terms.has(token)) {
            categoryAffinity.set(
              profileName,
              (categoryAffinity.get(profileName) || 0) + weight,
            );
          }
        });
      });
      return true;
    };

    const addValue = (value, weight) => addTokenList(tokenize(value), weight);
    const addCandidate = (candidate, weight) => {
      if (!candidate) return false;
      return addTokenList(candidateTokens(candidate).all, weight);
    };
    const addEvidence = (kind, strength, detail) => {
      if (strength <= 0) return;
      signalStrength += strength;
      evidence.push({ kind, strength, detail });
    };

    const mergedInteractions = new Map();
    [...(interactions || []), ...(remoteProfile?.interactions || [])].forEach((item) => {
      const sanitized = sanitizeInteraction(item, now, INTERACTION_MODEL_VERSION);
      if (!sanitized) return;
      mergedInteractions.set(
        sanitized.handle,
        mergeInteractionRecords(mergedInteractions.get(sanitized.handle), sanitized),
      );
    });

    mergedInteractions.forEach((item) => {
      const ageDays = Math.max(0, (now - item.lastInteraction) / 86_400_000);
      const recency = Math.pow(0.5, ageDays / 28);
      const sessionDiversity = 1 + Math.min(1.6, Math.log1p(item.sessionCount) * 0.42);
      const repeatedInterest =
        Math.log1p(item.viewCount) * 3.1 +
        Math.log1p(item.addCount) * 9.2 +
        Math.log1p(item.engagementWeight) * 1.25 +
        Math.log1p(item.purchaseCount) * 2.2;
      const positiveWeight = repeatedInterest * recency * sessionDiversity;
      if (addTokenList(item.tokens, positiveWeight)) {
        seenHandles.add(item.handle);
        addEvidence(
          item.addCount > 0 ? 'repeated-add' : 'repeated-view',
          Math.min(20, positiveWeight * 0.42),
          `${item.handle}:${item.viewCount}v/${item.addCount}a/${item.sessionCount}s`,
        );
      }
      item.categories.forEach((category) => {
        const profiles = CATEGORY_PROFILE_MAP[category] || [];
        profiles.forEach((profileName) => {
          categoryAffinity.set(
            profileName,
            (categoryAffinity.get(profileName) || 0) + positiveWeight * 1.25,
          );
        });
      });

      if (item.lastRemove && now - item.lastRemove <= NEGATIVE_SIGNAL_TTL_MS) {
        const removeAgeDays = Math.max(0, (now - item.lastRemove) / 86_400_000);
        const removeRecency = Math.pow(0.5, removeAgeDays / 7);
        const negativeWeight = Math.log1p(item.removeCount) * 1.8 * removeRecency;
        addTokenList(item.tokens, -negativeWeight);
        item.categories.forEach((category) => {
          negativeCategoryAffinity.set(
            category,
            (negativeCategoryAffinity.get(category) || 0) + negativeWeight,
          );
        });
        evidence.push({ kind: 'cart-remove', strength: -negativeWeight, detail: item.handle });
      }

      if (item.lastPurchase && now - item.lastPurchase <= PURCHASE_SUPPRESSION_TTL_MS) {
        purchasedHandles.add(item.handle);
      }
    });

    (cartContext?.items || []).forEach((item) => {
      if (item.handle) cartHandles.add(item.handle);
      if (item.variantId) cartVariantIds.add(item.variantId);
      const signal = compactSignalFromProduct(item);
      let meaningful = addTokenList(signal.tokens, 16);
      signal.categories.forEach((category) => {
        (CATEGORY_PROFILE_MAP[category] || []).forEach((profileName) => {
          categoryAffinity.set(profileName, (categoryAffinity.get(profileName) || 0) + 20);
        });
      });
      if (meaningful) addEvidence('cart', 12, item.handle || item.variantId);
    });

    pruneRecentVariantSignals();
    recentVariantSignals.forEach((_timestamp, variantId) => {
      cartVariantIds.add(variantId);
      if (addCandidate(candidatesByVariant.get(variantId), 18)) {
        addEvidence('recent-cart-line', 8, variantId);
      }
    });

    if (referrerHandle) {
      seenHandles.add(referrerHandle);
      if (addCandidate(candidatesByHandle.get(referrerHandle), 14)) {
        addEvidence('referrer', 6, referrerHandle);
      }
    }

    fatigueByHandle.forEach((record) => {
      if (!record.unengaged) return;
      const ageDays = Math.max(0, (now - record.lastShown) / 86_400_000);
      const decay = Math.pow(0.5, ageDays / 10);
      const categoryPenalty = Math.min(8, record.unengaged * 0.75) * decay;
      record.categories.forEach((category) => {
        negativeCategoryAffinity.set(
          category,
          (negativeCategoryAffinity.get(category) || 0) + categoryPenalty,
        );
      });
    });

    const positiveTokenCount = [...weightedTokens.values()].filter((weight) => weight > 0).length;
    const confidence = signalStrength + Math.min(8, positiveTokenCount * 0.28);
    return {
      weightedTokens,
      categoryAffinity,
      negativeCategoryAffinity,
      cartHandles,
      cartVariantIds,
      seenHandles,
      purchasedHandles,
      fatigueByHandle,
      signalStrength,
      confidence,
      evidence,
      isConfident: confidence >= MIN_SIGNAL_STRENGTH && positiveTokenCount >= 1,
    };
  };

  const weightedFieldScore = (tokens, profile, multiplier) =>
    tokens.reduce((sum, token) => sum + (profile.weightedTokens.get(token) || 0) * multiplier, 0);

  const scoreInterest = (candidate, profile) => {
    const fields = candidateTokens(candidate);
    const raw =
      weightedFieldScore(fields.title, profile, 1.15) +
      weightedFieldScore(fields.type, profile, 1.55) +
      weightedFieldScore(fields.tags, profile, 1.3) +
      weightedFieldScore(fields.vendor, profile, 0.35) +
      weightedFieldScore(fields.category, profile, 1.85) +
      weightedFieldScore(fields.collections, profile, 1.5) +
      weightedFieldScore(fields.keywords, profile, 2);
    const matches = fields.all.filter((token) => profile.weightedTokens.has(token)).length;
    return matches ? raw / Math.sqrt(Math.max(1, fields.all.length)) + matches * 0.8 : 0;
  };

  const scoreCategoryAffinity = (candidate, entry, profile) => {
    const terms = entry.profileTerms || PROFILE_TERMS[entry.profileName] || PROFILE_TERMS.collection;
    if (!terms.size) return 0;
    const fields = candidateTokens(candidate);
    const matching = fields.all.filter((token) => terms.has(token));
    if (!matching.length) return 0;
    const direct = matching.reduce(
      (sum, token) => sum + (profile.weightedTokens.get(token) || 0),
      0,
    );
    const profileAffinity = [...terms].reduce(
      (sum, token) => sum + (profile.weightedTokens.get(token) || 0),
      0,
    );
    const coverage = matching.length / Math.sqrt(Math.max(1, fields.all.length));
    return direct + Math.log1p(profileAffinity) * coverage * 2.8;
  };

  const candidateBroadCategories = (candidate) =>
    inferCategoriesFromTokens(candidateTokens(candidate).all);

  const scoreNegativeCategory = (candidate, profile) =>
    candidateBroadCategories(candidate).reduce(
      (sum, category) => sum + (profile.negativeCategoryAffinity.get(category) || 0),
      0,
    );

  const scoreCandidate = (candidate, entry, interestProfile) => {
    const profileName = entry.profileName;
    const data = candidateDataset(candidate);
    const rating = numeric(data.rating);
    const ratingCount = numeric(data.ratingCount);
    const popularity = numeric(data.popularity);
    const sourcePosition = Math.max(1, numeric(data.sourcePosition));
    const manualMode = candidateManualMode(candidate);
    const pinned = manualMode === 'pinned';
    const boosted = manualMode === 'boosted';
    const available = data.available === 'true';
    const handle = candidateHandle(candidate);
    const inCart = candidateInCart(candidate, interestProfile);
    const recentlySeen = interestProfile.seenHandles.has(handle);
    const fatigueRecord = interestProfile.fatigueByHandle.get(handle);
    const purchasedRecently = interestProfile.purchasedHandles.has(handle);

    let baseScore = available ? 100 : -1_000;
    if (profileName === 'top_rated_tech') {
      baseScore += rating * 125;
      baseScore += Math.log10(Math.max(1, ratingCount) + 1) * 75;
      baseScore += popularity * 0.45;
    } else {
      baseScore += popularity * 3.2;
      baseScore += rating * 38;
      baseScore += Math.log10(Math.max(1, ratingCount) + 1) * 28;
      baseScore += Math.max(0, 65 - sourcePosition * 3);
    }

    const interest = scoreInterest(candidate, interestProfile);
    const categoryAffinity = scoreCategoryAffinity(candidate, entry, interestProfile);
    const personalBoost = interest * 7 + categoryAffinity * 4.5;
    const manualBoost = pinned ? 1_000_000 : boosted ? 450 : 0;
    const nativeBoost = data.nativeRecommendation === 'true'
      ? Math.max(12, 110 - numeric(candidate.nativeRank) * 7)
      : 0;
    const cartPenalty = inCart && !pinned ? -8_000 : 0;
    const seenPenalty = recentlySeen && !inCart && !pinned ? -75 : 0;
    const fatiguePenalty = fatigueRecord && !pinned
      ? -Math.min(220, numeric(fatigueRecord.unengaged) * 18)
      : 0;
    const negativeCategoryPenalty = !pinned
      ? -Math.min(160, scoreNegativeCategory(candidate, interestProfile) * 12)
      : 0;
    const purchasePenalty = purchasedRecently && !pinned ? -12_000 : 0;
    const total =
      baseScore +
      personalBoost +
      manualBoost +
      nativeBoost +
      cartPenalty +
      seenPenalty +
      fatiguePenalty +
      negativeCategoryPenalty +
      purchasePenalty;

    return {
      total,
      baseScore,
      personalBoost,
      interest,
      categoryAffinity,
      manualBoost,
      nativeBoost,
      fatiguePenalty,
      negativeCategoryPenalty,
      purchasePenalty,
      manualMode,
      pinned,
      available,
      inCart,
      recentlySeen,
      purchasedRecently,
      sourcePosition,
    };
  };

  const buildPlans = (state, personalize, interestProfile) =>
    state.columns.map((entry) => {
      const eligibleCandidates = entry.candidates.filter((candidate) =>
        categoryGateAllowsCandidate(candidate, entry),
      );
      const scored = eligibleCandidates.map((candidate, index) => {
        const breakdown = personalize
          ? scoreCandidate(candidate, entry, interestProfile)
          : {
              total: -index,
              baseScore: -index,
              personalBoost: 0,
              manualMode: candidateManualMode(candidate),
              pinned: candidateManualMode(candidate) === 'pinned',
              available: candidateDataset(candidate).available === 'true',
              inCart: false,
              sourcePosition: index + 1,
            };
        candidate.score = breakdown;
        return { candidate, index, score: breakdown.total, breakdown };
      });

      let ranked = [...scored];
      if (personalize && interestProfile.isConfident) {
        const strong = scored
          .filter(
            (item) =>
              item.breakdown.pinned ||
              item.breakdown.manualMode === 'boosted' ||
              item.breakdown.personalBoost >= MIN_PERSONAL_BOOST,
          )
          .sort((left, right) => right.score - left.score || left.index - right.index);
        const strongSet = new Set(strong.map((item) => item.candidate));
        const remaining = scored
          .filter((item) => !strongSet.has(item.candidate))
          .sort(
            (left, right) =>
              right.breakdown.baseScore - left.breakdown.baseScore || left.index - right.index,
          );
        ranked = [...strong, ...remaining];
      } else {
        ranked.sort((left, right) => left.index - right.index);
      }

      return {
        ...entry,
        ranked,
        selected: [],
        eligibleCount: eligibleCandidates.length,
        rejectedCount: Math.max(0, entry.candidates.length - eligibleCandidates.length),
      };
    });

  const candidateTier = (item, usedHandles, profile) => {
    const handle = candidateHandle(item.candidate);
    const duplicate = Boolean(handle && usedHandles.has(handle));
    const inCart = candidateInCart(item.candidate, profile);
    const available = item.breakdown.available;
    const pinned = item.breakdown.pinned;
    if (pinned) return -1;
    if (available && !inCart && !duplicate) return 0;
    if (available && !inCart && duplicate) return 1;
    if (available && inCart && !duplicate) return 2;
    if (available && inCart && duplicate) return 3;
    if (!available && !inCart && !duplicate) return 4;
    if (!available && !inCart && duplicate) return 5;
    if (!available && inCart && !duplicate) return 6;
    return 7;
  };

  const assignProductsAcrossColumns = (plans, interestProfile) => {
    const usedHandles = new Set();

    plans.forEach((plan) => {
      plan.ranked
        .filter((item) => item.breakdown.pinned)
        .slice(0, plan.displayCount)
        .forEach((item) => {
          const handle = candidateHandle(item.candidate);
          // Even pinned recommendations must be unique across all visible columns.
          if (plan.selected.includes(item.candidate) || (handle && usedHandles.has(handle))) return;
          plan.selected.push(item.candidate);
          if (handle) usedHandles.add(handle);
        });
    });

    const maxSlots = Math.max(0, ...plans.map((plan) => plan.displayCount));
    for (let slot = 0; slot < maxSlots; slot += 1) {
      const pending = new Set(plans.filter((plan) => plan.selected.length < plan.displayCount));
      while (pending.size) {
        const choices = [...pending]
          .map((plan) => {
            const candidates = plan.ranked.filter((item) => {
              const handle = candidateHandle(item.candidate);
              return !plan.selected.includes(item.candidate) &&
                (!handle || !usedHandles.has(handle));
            });
            if (!candidates.length) return null;
            const bestTier = Math.min(
              ...candidates.map((item) => candidateTier(item, usedHandles, interestProfile)),
            );
            const tierItems = candidates
              .filter(
                (item) => candidateTier(item, usedHandles, interestProfile) === bestTier,
              )
              .sort((left, right) => right.score - left.score || left.index - right.index);
            const best = tierItems[0];
            const second = tierItems[1];
            const regret = second ? best.score - second.score : 1_000;
            const scarcity = 1_000 / (tierItems.length + 1);
            return {
              plan,
              best,
              tier: bestTier,
              priority: -bestTier * 1_000_000 + best.score + regret + scarcity,
            };
          })
          .filter(Boolean)
          .sort((left, right) => right.priority - left.priority);

        if (!choices.length) break;
        const choice = choices[0];
        choice.plan.selected.push(choice.best.candidate);
        const handle = candidateHandle(choice.best.candidate);
        if (handle) usedHandles.add(handle);
        pending.delete(choice.plan);
      }
    }

    return plans;
  };

  const applyLayoutClasses = (column, visibleCards) => {
    const isMosaic = column.classList.contains('z2fc__column--mosaic');
    const mosaicClasses = [
      'z2fc__product-card--mosaic-a',
      'z2fc__product-card--mosaic-b',
      'z2fc__product-card--mosaic-c',
      'z2fc__product-card--mosaic-d',
      'z2fc__product-card--mosaic-e',
    ];
    visibleCards.forEach((card) => card.classList.remove(...mosaicClasses));
    if (isMosaic) {
      visibleCards.forEach((card, index) => {
        if (mosaicClasses[index]) card.classList.add(mosaicClasses[index]);
      });
    }
  };

  const isNearViewport = (root) => {
    const rect = root.getBoundingClientRect?.();
    if (!rect) return false;
    return rect.top < window.innerHeight * 1.35 && rect.bottom > -window.innerHeight * 0.25;
  };

  const settleImage = (image) => {
    const wrapper = image.closest?.('.z2fc__product-image');
    if (!wrapper) return;
    wrapper.classList.remove('is-loading');
    if (image.naturalWidth > 0) {
      wrapper.classList.add('is-loaded');
      wrapper.classList.remove('has-error');
    } else {
      wrapper.classList.add('has-error');
      wrapper.classList.remove('is-loaded');
    }
  };

  const initializeLoadedImage = (image, signal) => {
    if (initializedImages.has(image)) return;
    initializedImages.add(image);
    if (!image.currentSrc && !image.getAttribute('src')) return;
    if (image.complete) {
      settleImage(image);
      return;
    }
    image.addEventListener('load', () => settleImage(image), { once: true, signal });
    image.addEventListener('error', () => settleImage(image), { once: true, signal });
  };

  const hydrateImage = (image, root, signal) => {
    if (!image) return;
    if (image.dataset.z2fcHydrated === 'true') {
      initializeLoadedImage(image, signal);
      return;
    }
    const source = image.dataset.z2fcSrc;
    if (!source) {
      initializeLoadedImage(image, signal);
      return;
    }

    const shouldPrioritize =
      image.dataset.z2fcImagePriority === 'high' && isNearViewport(root);
    image.loading = shouldPrioritize ? 'eager' : 'lazy';
    if ('fetchPriority' in image) image.fetchPriority = shouldPrioritize ? 'high' : 'auto';
    image.decoding = 'async';
    image.dataset.z2fcHydrated = 'true';

    const onLoad = () => settleImage(image);
    const onError = () => settleImage(image);
    image.addEventListener('load', onLoad, { once: true, signal });
    image.addEventListener('error', onError, { once: true, signal });
    initializedImages.add(image);

    if (image.dataset.z2fcSizes) image.sizes = image.dataset.z2fcSizes;
    if (image.dataset.z2fcSrcset) image.srcset = image.dataset.z2fcSrcset;
    image.src = source;

    if (image.complete) {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
      settleImage(image);
    }
  };

  const hydrateCards = (root, cards, signal) => {
    cards.forEach((card) => {
      card.querySelectorAll(PRODUCT_IMAGE_SELECTOR).forEach((image) => {
        hydrateImage(image, root, signal);
      });
    });
  };

  const observeCandidateImpressions = (root, state, cards) => {
    if (!behaviorTrackingAllowed()) return;
    cards.forEach((card) => {
      const handle = card?.dataset?.productHandle || '';
      if (!handle || state.impressedHandles.has(handle)) return;
      if (state.impressionObserver) {
        state.impressionObserver.observe(card);
        return;
      }
      const rect = card.getBoundingClientRect?.();
      if (rect && rect.top < window.innerHeight && rect.bottom > 0) {
        state.impressedHandles.add(handle);
        const product = productFromElement(card);
        recordFatigueImpression(product);
        recordMetric(root, 'impression', product);
      }
    });
  };

  const hydrateBanners = (root, signal) => {
    root.querySelectorAll(BANNER_IMAGE_SELECTOR).forEach((image) => {
      hydrateImage(image, root, signal);
    });
  };

  const signatureForPlans = (plans) =>
    plans
      .map((plan) => plan.selected.map(candidateHandle).join(','))
      .join('|');

  const announceUpdate = (root, state) => {
    const status = root.querySelector('[data-z2fc-status]');
    const message = root.dataset.updateMessage || 'Product recommendations updated';
    if (!status || !message) return;
    window.clearTimeout(state.statusTimer);
    status.textContent = '';
    state.statusTimer = window.setTimeout(() => {
      if (root.isConnected) status.textContent = message;
    }, 40);
  };

  const escapeSelectorValue = (value) => {
    if (window.CSS?.escape) return window.CSS.escape(value);
    return String(value || '').replace(/["\\]/gu, '\\$&');
  };

  const captureFocusedProduct = (root) => {
    const active = document.activeElement;
    if (!active || !root.contains(active)) return null;
    const card = active.closest?.(CARD_SELECTOR);
    const handle = card?.dataset?.productHandle || '';
    if (!handle) return null;
    return { handle, wasLink: Boolean(active.closest?.(LINK_SELECTOR)) };
  };

  const preserveFocusedCandidate = (plans, focused) => {
    if (!focused?.handle) return;
    const plan = plans.find((entry) =>
      entry.candidates.some((candidate) => candidateHandle(candidate) === focused.handle),
    );
    if (!plan) return;
    const focusedCandidate = plan.candidates.find(
      (candidate) => candidateHandle(candidate) === focused.handle,
    );
    if (!focusedCandidate || plan.selected.includes(focusedCandidate)) return;
    // Do not reinsert a product already selected by a different column.
    if (plans.some((entry) => entry !== plan && entry.selected.some(
      (candidate) => candidateHandle(candidate) === focused.handle,
    ))) return;

    const replaceIndex = [...plan.selected]
      .map((candidate, index) => ({ candidate, index }))
      .reverse()
      .find(({ candidate }) => candidateManualMode(candidate) !== 'pinned')?.index;
    if (replaceIndex === undefined) return;
    plan.selected.splice(replaceIndex, 1, focusedCandidate);
  };

  const restoreFocusedProduct = (root, focused) => {
    if (!focused?.handle || !focused.wasLink) return;
    const selector = `[data-product-handle="${escapeSelectorValue(focused.handle)}"]${LINK_SELECTOR}`;
    const target = root.querySelector(selector);
    if (!target || document.activeElement === target) return;
    window.requestAnimationFrame(() => {
      if (!target.isConnected) return;
      try {
        target.focus({ preventScroll: true });
      } catch (_error) {
        target.focus();
      }
    });
  };

  const applyPlans = (root, state, plans, { announce = false, personalized = false } = {}) => {
    const focused = captureFocusedProduct(root);
    preserveFocusedCandidate(plans, focused);
    const signature = signatureForPlans(plans);
    const changed = Boolean(state.lastSignature && state.lastSignature !== signature);

    plans.forEach((plan) => {
      if (!plan.grid) return;
      const selectedSet = new Set(plan.selected);
      const visibleCards = [];

      plan.candidates.forEach((candidate) => {
        if (selectedSet.has(candidate)) return;
        if (candidate.card?.isConnected) candidate.card.remove();
      });

      const fragment = document.createDocumentFragment();
      plan.selected.forEach((candidate) => {
        const card = materializeCandidate(candidate);
        if (!card) return;
        visibleCards.push(card);
        fragment.append(card);
      });

      plan.grid.classList.add('is-updating');
      plan.grid.append(fragment);
      window.requestAnimationFrame(() => plan.grid?.classList.remove('is-updating'));
      applyLayoutClasses(plan.column, visibleCards);
      hydrateCards(root, visibleCards, state.lifecycle.signal);
      observeCandidateImpressions(root, state, visibleCards);
    });

    updatePriceDropBadges(root);
    root.classList.toggle('z2fc--personalized-ready', personalized);
    state.lastSignature = signature;
    restoreFocusedProduct(root, focused);
    if (announce && changed) announceUpdate(root, state);
    return changed;
  };

  const restoreDefaultOrder = (root, state) => {
    // The default/holdout/low-signal path must be unique too, not only the
    // personalized path. This matches the server-rendered Liquid selection.
    const usedHandles = new Set();
    const plans = state.columns.map((entry) => {
      const selected = [];
      entry.candidates.forEach((candidate) => {
        if (selected.length >= entry.displayCount) return;
        const handle = candidateHandle(candidate);
        if (handle && usedHandles.has(handle)) return;
        selected.push(candidate);
        if (handle) usedHandles.add(handle);
      });
      return { ...entry, selected };
    });
    applyPlans(root, state, plans, { announce: false, personalized: false });
  };

  const debugEnabled = (root) =>
    root.dataset.designMode === 'true' && root.dataset.debugPersonalization === 'true';

  const diagnosticsForPlans = (plans) =>
    plans.flatMap((plan, columnIndex) =>
      plan.ranked.slice(0, Math.max(plan.displayCount, 6)).map((item, rank) => ({
        column: columnIndex + 1,
        profile: plan.profileName,
        rank: rank + 1,
        selected: plan.selected.includes(item.candidate),
        product: candidateDataset(item.candidate).productTitle,
        handle: candidateHandle(item.candidate),
        total: Math.round(item.breakdown.total * 10) / 10,
        base: Math.round(item.breakdown.baseScore * 10) / 10,
        personal: Math.round((item.breakdown.personalBoost || 0) * 10) / 10,
        affinity: Math.round((item.breakdown.categoryAffinity || 0) * 10) / 10,
        manual: item.breakdown.manualMode,
        inCart: item.breakdown.inCart,
      })),
    );

  const logDiagnostics = (root, state, details) => {
    const snapshot = {
      reason: details.reason,
      permissions: { ...(details.permissions || {}) },
      experiment: details.assignment || state.experimentAssignment || null,
      confidence: {
        signalStrength: details.profile?.signalStrength || 0,
        confidence: details.profile?.confidence || 0,
        isConfident: details.profile?.isConfident || false,
        tokenCount: details.profile?.weightedTokens?.size || 0,
      },
      evidence: (details.profile?.evidence || []).map((item) => ({ ...item })),
      cartItems: (details.cartContext?.items || []).map((item) => ({ ...item })),
      ranking: details.plans ? diagnosticsForPlans(details.plans) : [],
    };
    state.lastDiagnostics = snapshot;
    if (!debugEnabled(root)) return;
    console.groupCollapsed(`[Z2FC ${VERSION}]${snapshot.reason}`);
    console.log('permissions', snapshot.permissions);
    console.log('experiment', snapshot.experiment);
    console.log('confidence', snapshot.confidence);
    console.log('evidence', snapshot.evidence);
    console.log('cart items', snapshot.cartItems);
    if (snapshot.ranking.length) console.table(snapshot.ranking);
    console.groupEnd();
  };

  const rootIsInteracting = (state) =>
    Boolean(state.pointerInside || state.focusInside || state.touchActive);

  const mergePersonalizationOptions = (current = {}, incoming = {}) => {
    const previousOptions = current || {};
    const nextOptions = incoming || {};
    return {
      ...previousOptions,
      ...nextOptions,
      forceCart: Boolean(previousOptions.forceCart || nextOptions.forceCart),
      reason: nextOptions.reason || previousOptions.reason || 'deferred-update',
    };
  };

  const runPendingPersonalization = (root, state) => {
    window.clearTimeout(state.coalesceTimer);
    state.coalesceTimer = 0;
    if (!state.activated || rootIsInteracting(state) || !state.pendingPersonalization) return;
    const options = state.pendingPersonalization;
    state.pendingPersonalization = null;
    personalizeRoot(root, options);
  };

  const schedulePendingPersonalization = (root, state) => {
    window.clearTimeout(state.interactionTimer);
    if (!state.activated || rootIsInteracting(state) || !state.pendingPersonalization) return;
    state.interactionTimer = window.setTimeout(
      () => {
        window.clearTimeout(state.coalesceTimer);
        state.coalesceTimer = window.setTimeout(
          () => runPendingPersonalization(root, state),
          COALESCE_MS,
        );
      },
      INTERACTION_IDLE_MS,
    );
  };

  const requestPersonalization = (root, options = {}) => {
    const state = rootStates.get(root);
    if (!state || root.dataset.personalization !== 'true') return;
    state.pendingPersonalization = mergePersonalizationOptions(
      state.pendingPersonalization,
      options,
    );
    if (!state.activated) return;
    if (rootIsInteracting(state) && !options.immediate) return;
    window.clearTimeout(state.interactionTimer);
    window.clearTimeout(state.coalesceTimer);
    if (options.immediate) {
      runPendingPersonalization(root, state);
      return;
    }
    state.coalesceTimer = window.setTimeout(
      () => runPendingPersonalization(root, state),
      COALESCE_MS,
    );
  };

  const activateRoot = (root, state) => {
    if (state.activated) return;
    state.activated = true;
    state.activationObserver?.disconnect();
    state.activationObserver = null;
    requestPersonalization(root, {
      reason: state.pendingPersonalization?.reason || 'viewport-activation',
      ...(state.pendingPersonalization || {}),
      immediate: root.dataset.designMode === 'true',
    });
  };

  const deferPersonalizationForInteraction = (root, state, options = {}) => {
    if (!rootIsInteracting(state)) return false;
    state.pendingPersonalization = mergePersonalizationOptions(
      state.pendingPersonalization,
      options,
    );
    schedulePendingPersonalization(root, state);
    return true;
  };

  const isCurrentRun = (root, state, runId) =>
    root.isConnected && rootStates.get(root) === state && state.runId === runId;

  const queueReferrerEnrichment = (root, state, handle) => {
    if (!handle || state.referrerHandle === handle || !behaviorTrackingAllowed()) return;
    state.referrerHandle = handle;
    fetchReferrerProduct(handle).then((recorded) => {
      if (recorded && root.isConnected && rootStates.get(root) === state) {
        requestPersonalization(root, { reason: 'referrer-enriched', skipReferrerFetch: true });
      }
    });
  };

  const personalizeRoot = async (
    root,
    { reason = 'manual', summaryHint = undefined, forceCart = false, skipReferrerFetch = false } = {},
  ) => {
    const state = rootStates.get(root);
    if (!state) return;

    state.runController?.abort();
    state.runController = new AbortController();
    state.runId += 1;
    const runId = state.runId;
    const signal = state.runController.signal;

    if (root.dataset.personalization !== 'true') {
      root.classList.remove('z2fc--personalization-pending');
      root.removeAttribute('aria-busy');
      restoreDefaultOrder(root, state);
      logDiagnostics(root, state, { reason: `${reason}:disabled`, permissions: {}, profile: null });
      return;
    }

    await ensureCustomerPrivacy();
    if (!isCurrentRun(root, state, runId)) return;

    const permissions = getPrivacyPermissions();

    root.classList.add('z2fc--personalization-pending');
    root.setAttribute('aria-busy', 'true');

    try {
      const assignment = getExperimentAssignment(root);
      state.experimentAssignment = assignment;
      if (assignment.group === 'holdout') {
        if (deferPersonalizationForInteraction(root, state, {
          reason: `${reason}:holdout-after-interaction`,
          forceCart: false,
        })) return;
        restoreDefaultOrder(root, state);
        state.hasCompletedInitialRun = true;
        logDiagnostics(root, state, {
          reason: `${reason}:holdout`,
          permissions,
          profile: null,
          cartContext: null,
          plans: null,
          assignment,
        });
        return;
      }

      const [cartContext, remoteProfile] = await Promise.all([
        getCartContext({ force: forceCart, signal, summaryHint }),
        loadRemoteProfile(root, signal),
      ]);
      if (!isCurrentRun(root, state, runId)) return;

      const interactions = readInteractions();
      const referrerHandle = getReferrerHandle();
      let profile = buildInterestProfile(
        state,
        interactions,
        cartContext,
        referrerHandle,
        remoteProfile,
      );

      if (profile.isConfident) {
        await enrichWithNativeRecommendations(root, state, interactions, cartContext, signal);
        if (!isCurrentRun(root, state, runId)) return;
        profile = buildInterestProfile(
          state,
          interactions,
          cartContext,
          referrerHandle,
          remoteProfile,
        );
      }

      if (!profile.isConfident) {
        if (deferPersonalizationForInteraction(root, state, {
          reason: `${reason}:after-interaction`,
          forceCart: false,
        })) return;
        restoreDefaultOrder(root, state);
        state.hasCompletedInitialRun = true;
        logDiagnostics(root, state, {
          reason: `${reason}:low-confidence`,
          permissions,
          profile,
          cartContext,
          plans: null,
          assignment,
        });
      } else {
        const plans = assignProductsAcrossColumns(
          buildPlans(state, true, profile),
          profile,
        );
        if (!isCurrentRun(root, state, runId)) return;
        if (deferPersonalizationForInteraction(root, state, {
          reason: `${reason}:after-interaction`,
          forceCart: false,
        })) return;
        applyPlans(root, state, plans, {
          announce: state.hasCompletedInitialRun,
          personalized: true,
        });
        state.hasCompletedInitialRun = true;
        logDiagnostics(root, state, {
          reason,
          permissions,
          profile,
          cartContext,
          plans,
          assignment,
        });
      }

      if (!skipReferrerFetch && referrerHandle) {
        queueReferrerEnrichment(root, state, referrerHandle);
      }
    } catch (error) {
      if (error?.name !== 'AbortError' && debugEnabled(root)) {
        console.warn('[Z2FC:PERSONALIZATION_FAILED]', error);
      }
      if (isCurrentRun(root, state, runId) && !rootIsInteracting(state)) {
        restoreDefaultOrder(root, state);
      }
    } finally {
      if (isCurrentRun(root, state, runId)) {
        root.classList.remove('z2fc--personalization-pending');
        root.removeAttribute('aria-busy');
      }
    }
  };

  const prefersReducedMotion = () =>
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;

  const scrollBlockIntoView = (block) => {
    const column = block.matches?.(COLUMN_SELECTOR) ? block : block.closest?.(COLUMN_SELECTOR);
    const root = column?.closest?.(ROOT_SELECTOR);
    const state = root ? rootStates.get(root) : null;
    if (!column || !root || !state) return;

    const columnState = state.columns.find((entry) => entry.column === column);
    const visibleCards = columnState
      ? columnState.candidates.map((candidate) => candidate.card).filter((card) => card?.isConnected)
      : [];
    hydrateCards(root, visibleCards, state.lifecycle.signal);
  };

  const bindRoot = (root) => {
    if (rootStates.has(root)) return;

    purgeInvalidStrictColumnCards(root);

    const lifecycle = new AbortController();
    const state = {
      lifecycle,
      runController: null,
      runId: 0,
      activationObserver: null,
      impressionObserver: null,
      impressedHandles: new Set(),
      coalesceTimer: 0,
      interactionTimer: 0,
      pointerInside: false,
      focusInside: false,
      touchActive: false,
      activated: false,
      pendingPersonalization: { reason: 'initial' },
      columns: [],
      lastSignature: '',
      hasCompletedInitialRun: false,
      referrerHandle: '',
      statusTimer: 0,
      mobileLiftTimer: 0,
      mobileLiftedCard: null,
      mobilePointerId: null,
      mobilePointerStartX: 0,
      mobilePointerStartY: 0,
      mobilePointerMoved: false,
      lastTouchPointerAt: 0,
      lastDiagnostics: null,
    };
    state.columns = collectColumns(root);
    rootStates.set(root, state);

    if ('IntersectionObserver' in window) {
      state.impressionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.intersectionRatio < IMPRESSION_THRESHOLD) return;
            const card = entry.target;
            const handle = card?.dataset?.productHandle || '';
            state.impressionObserver?.unobserve(card);
            if (!handle || state.impressedHandles.has(handle)) return;
            state.impressedHandles.add(handle);
            const product = productFromElement(card);
            recordFatigueImpression(product);
            recordMetric(root, 'impression', product);
          });
        },
        { threshold: [IMPRESSION_THRESHOLD] },
      );
    }

    hydrateBanners(root, lifecycle.signal);
    restoreDefaultOrder(root, state);

    const mobileTrack = root.querySelector('[data-z2fc-track]');
    const mobileSwipeHint = root.querySelector('[data-z2fc-swipe-hint]');
    if (mobileTrack && mobileSwipeHint) {
      const dismissSwipeHint = () => {
        if (Math.abs(mobileTrack.scrollLeft) < 8) return;
        mobileSwipeHint.classList.add('is-dismissed');
      };
      mobileTrack.addEventListener('scroll', dismissSwipeHint, {
        passive: true,
        signal: lifecycle.signal,
      });
    }

    /* Mobile touch uplift mirrors the desktop hover treatment without breaking swipes. */
    const coarsePointerQuery = window.matchMedia?.('(hover: none), (pointer: coarse)');
    const reducedMotionQuery = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    const mobileLiftEnabled = () => Boolean(coarsePointerQuery?.matches);
    const clearMobileLift = () => {
      window.clearTimeout(state.mobileLiftTimer);
      state.mobileLiftTimer = 0;
      state.mobileLiftedCard?.classList.remove('is-mobile-lifted');
      state.mobileLiftedCard = null;
      state.mobilePointerId = null;
      state.mobilePointerMoved = false;
    };
    const activateMobileLift = (card) => {
      if (!card) return;
      if (state.mobileLiftedCard && state.mobileLiftedCard !== card) {
        state.mobileLiftedCard.classList.remove('is-mobile-lifted');
      }
      state.mobileLiftedCard = card;
      card.classList.add('is-mobile-lifted');
    };
    root.addEventListener('pointerdown', (event) => {
      if (!mobileLiftEnabled()) return;
      if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
      const link = event.target.closest?.(LINK_SELECTOR);
      if (!link || !root.contains(link)) return;
      const card = link.closest(CARD_SELECTOR);
      if (!card) return;
      window.clearTimeout(state.mobileLiftTimer);
      state.mobilePointerId = event.pointerId;
      state.mobilePointerStartX = event.clientX;
      state.mobilePointerStartY = event.clientY;
      state.mobilePointerMoved = false;
      state.lastTouchPointerAt = Date.now();
      activateMobileLift(card);
    }, { passive: true, signal: lifecycle.signal });
    root.addEventListener('pointermove', (event) => {
      if (event.pointerId !== state.mobilePointerId) return;
      const movedX = Math.abs(event.clientX - state.mobilePointerStartX);
      const movedY = Math.abs(event.clientY - state.mobilePointerStartY);
      if (movedX <= MOBILE_LIFT_MOVE_TOLERANCE && movedY <= MOBILE_LIFT_MOVE_TOLERANCE) return;
      state.mobilePointerMoved = true;
      state.mobileLiftedCard?.classList.remove('is-mobile-lifted');
      state.mobileLiftedCard = null;
    }, { passive: true, signal: lifecycle.signal });
    root.addEventListener('pointercancel', clearMobileLift, {
      passive: true,
      signal: lifecycle.signal,
    });

    root.addEventListener('click', (event) => {
      if (!mobileLiftEnabled()) return;
      if (event.defaultPrevented || event.detail === 0) return;
      if (Date.now() - state.lastTouchPointerAt > 1500 || state.mobilePointerMoved) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest?.(LINK_SELECTOR);
      if (!link || !root.contains(link) || link.hasAttribute('download')) return;
      const target = link.getAttribute('target');
      if (target && target !== '_self') return;
      const href = link.href;
      if (!href) return;
      activateMobileLift(link.closest(CARD_SELECTOR));
      event.preventDefault();
      window.clearTimeout(state.mobileLiftTimer);
      const delay = reducedMotionQuery?.matches ? 0 : MOBILE_LIFT_DELAY_MS;
      state.mobileLiftTimer = window.setTimeout(() => {
        state.mobileLiftTimer = 0;
        window.location.assign(href);
      }, delay);
    }, { capture: true, signal: lifecycle.signal });

    if (root.dataset.personalization === 'true') {
      root.addEventListener(
        'click',
        (event) => {
          if (!behaviorTrackingAllowed()) return;
              const link = event.target.closest?.(LINK_SELECTOR);
          if (!link || !root.contains(link)) return;
          const card = link.closest(CARD_SELECTOR);
          if (card) {
            const product = productFromElement(card);
            recordInteraction('view', product);
            recordFatigueAction(product, 'click');
            recordMetric(root, 'click', product);
          }
        },
        { signal: lifecycle.signal },
      );
    }

    const setPointerInside = (value) => {
      state.pointerInside = value;
      if (!value) schedulePendingPersonalization(root, state);
    };
    const setTouchActive = (value) => {
      state.touchActive = value;
      if (!value) schedulePendingPersonalization(root, state);
    };

    root.addEventListener('pointerenter', () => setPointerInside(true), {
      passive: true,
      signal: lifecycle.signal,
    });
    root.addEventListener('pointerleave', () => setPointerInside(false), {
      passive: true,
      signal: lifecycle.signal,
    });
    root.addEventListener('touchstart', () => setTouchActive(true), {
      passive: true,
      signal: lifecycle.signal,
    });
    root.addEventListener('touchend', () => setTouchActive(false), {
      passive: true,
      signal: lifecycle.signal,
    });
    root.addEventListener('touchcancel', () => setTouchActive(false), {
      passive: true,
      signal: lifecycle.signal,
    });
    root.addEventListener('focusin', () => {
      state.focusInside = true;
    }, { signal: lifecycle.signal });

    root.addEventListener('focusout', () => {
      window.requestAnimationFrame(() => {
        state.focusInside = root.contains(document.activeElement);
        if (!state.focusInside) schedulePendingPersonalization(root, state);
      });
    }, { signal: lifecycle.signal });

    if (
      root.dataset.designMode === 'true' ||
      isNearViewport(root) ||
      !('IntersectionObserver' in window)
    ) {
      activateRoot(root, state);
    } else {
      state.activationObserver = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting || entry.intersectionRatio > 0)) {
            activateRoot(root, state);
          }
        },
        { rootMargin: INTERSECTION_ROOT_MARGIN, threshold: 0.01 },
      );
      state.activationObserver.observe(root);
    }
  };

  const destroyRoot = (root) => {
    const state = rootStates.get(root);
    if (!state) return;
    window.clearTimeout(state.statusTimer);
    window.clearTimeout(state.coalesceTimer);
    window.clearTimeout(state.interactionTimer);
    window.clearTimeout(state.mobileLiftTimer);
    state.mobileLiftedCard?.classList.remove('is-mobile-lifted');
    state.runController?.abort();
    state.activationObserver?.disconnect();
    state.impressionObserver?.disconnect();
    state.lifecycle.abort();
    rootStates.delete(root);
  };

  const initialize = (scope = document) => {
    const roots = [];
    if (scope.matches?.(ROOT_SELECTOR)) roots.push(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => roots.push(root));
    roots.forEach(bindRoot);
  };

  const destroyInScope = (scope) => {
    if (scope.matches?.(ROOT_SELECTOR)) destroyRoot(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => destroyRoot(root));
  };

  const executePersonalizedRootRerun = () => {
    window.clearTimeout(globalRerunTimer);
    globalRerunTimer = 0;
    const options = pendingGlobalRerun || { reason: 'coalesced-update' };
    pendingGlobalRerun = null;
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (root.dataset.personalization === 'true') requestPersonalization(root, options);
    });
  };

  const rerunPersonalizedRoots = (options = {}) => {
    pendingGlobalRerun = mergePersonalizationOptions(pendingGlobalRerun, options);
    window.clearTimeout(globalRerunTimer);
    globalRerunTimer = window.setTimeout(executePersonalizedRootRerun, COALESCE_MS);
  };

  const productFromStorefrontLink = (link) => {
    if (!link) return null;
    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (_error) {
      return null;
    }
    if (url.origin !== window.location.origin) return null;
    const handle = getProductHandleFromPath(url.pathname);
    if (!handle) return null;

    const image = link.querySelector?.('img');
    const nearbyCard = link.closest?.('[data-product-id], [data-product-handle], product-card, .card-wrapper, .product-card');
    const title = boundedString(
      link.dataset?.productTitle ||
      nearbyCard?.dataset?.productTitle ||
      image?.alt ||
      link.getAttribute('aria-label') ||
      link.textContent ||
      '',
      240,
    ).trim();

    return {
      handle,
      productId: normalizeId(link.dataset?.productId || nearbyCard?.dataset?.productId || ''),
      variantId: normalizeId(link.dataset?.variantId || nearbyCard?.dataset?.variantId || url.searchParams.get('variant') || ''),
      title,
      type: '',
      vendor: '',
      tags: '',
      category: '',
      collections: '',
      keywords: '',
      url: `${url.pathname}${url.search}`,
    };
  };

  const handleStorefrontProductClick = (event) => {
    const link = event.target?.closest?.('a[href]');
    if (!link || link.closest(ROOT_SELECTOR) || link.hasAttribute('download')) return;
    const product = productFromStorefrontLink(link);
    if (!product) return;

    // This runs in capture phase, so the interaction reaches storage before the
    // browser navigates to the product page.
    recordInteraction('view', product);
    recordFatigueAction(product, 'click');
    recordMetricForRoots('click', product);
  };

  const scheduleCartVerification = (reason = 'cart-verify') => {
    window.clearTimeout(cartVerificationTimer);
    cartVerificationTimer = window.setTimeout(async () => {
      cartVerificationTimer = 0;
      invalidateCart();
      await getCartContext({ force: true }).catch(() => null);
      rerunPersonalizedRoots({ reason, forceCart: false });
    }, 1100);
  };

  const scheduleCartRefresh = (summary, reason = 'cart-event') => {
    pendingCartRefresh = {
      summary: summary !== undefined ? summary : pendingCartRefresh?.summary,
      reason,
    };
    window.clearTimeout(cartRefreshTimer);
    cartRefreshTimer = window.setTimeout(async () => {
      const pending = pendingCartRefresh || { summary: undefined, reason };
      pendingCartRefresh = null;
      cartRefreshTimer = 0;
      if (pending.summary !== undefined) primeCartSummary(pending.summary);
      else invalidateCart();
      await getCartContext({
        force: true,
        summaryHint: pending.summary,
      }).catch(() => null);
      rerunPersonalizedRoots({
        reason: pending.reason,
        summaryHint: pending.summary,
        forceCart: false,
      });
      scheduleCartVerification(`${pending.reason}-verified`);
    }, COALESCE_MS);
  };

  const handleStandardCartLinesUpdate = (event) => {
    recordRecentCartLines(event.lines);
    if (!event.promise || typeof event.promise.then !== 'function') {
      scheduleCartRefresh(undefined, 'cart-event');
      return;
    }

    event.promise
      .then((result) => {
        if (result?.userErrors?.length) return;
        scheduleCartRefresh(result?.cart || null, 'cart-event');
      })
      .catch(() => invalidateCart());
  };

  const handleLegacyCartChange = () => {
    scheduleCartRefresh(undefined, 'legacy-cart-event');
  };

  const handleProductView = (event) => {
    if (!behaviorTrackingAllowed()) return;
    const product = event?.product || event?.detail?.product || event?.detail;
    if (!product || typeof product !== 'object') return;
    const handle = product.handle || product.productHandle || '';
    if (!handle) return;
    const currentHandle = getProductHandleFromPath(window.location.pathname);
    if (currentHandle === handle && recordedCurrentPageHandles.has(handle)) return;
    if (currentHandle === handle) recordedCurrentPageHandles.add(handle);
    const normalized = {
      handle,
      productId: product.id || product.productId || product.product_id || '',
      variantId: product.variantId || product.variant_id || product.selectedVariant?.id || '',
      title: product.title || product.productTitle || '',
      type: product.type || product.productType || '',
      vendor: product.vendor || '',
      tags: Array.isArray(product.tags) ? product.tags.join('||') : product.tags || '',
      category: product.category?.name || product.category || '',
      collections: Array.isArray(product.collections)
        ? product.collections.map((collection) => collection?.handle || collection?.title || collection).join(' ')
        : product.collections || '',
      keywords: product.keywords || '',
      url: product.url || `/products/${handle}`,
    };
    recordInteraction('view', normalized);
    sendRemoteEvent(document.querySelector(ROOT_SELECTOR), 'view', normalized);
  };

  const handlePurchaseEvent = (event) => {
    const detail = event?.detail || event?.data || event || {};
    const products = Array.isArray(detail.products)
      ? detail.products
      : Array.isArray(detail.lineItems)
        ? detail.lineItems
        : detail.product
          ? [detail.product]
          : [];
    products.forEach((product) => {
      const handle = product?.handle || product?.productHandle || product?.product?.handle || '';
      if (!handle) return;
      const normalized = {
        ...productFromAjaxResponse(product?.product || product, handle),
        handle,
        productId: product?.productId || product?.product_id || product?.product?.id || '',
        variantId: product?.variantId || product?.variant_id || product?.id || '',
      };
      recordInteraction('purchase', normalized);
      recordFatigueAction(normalized, 'purchase');
      recordMetricForRoots('purchase', normalized);
    });
    rerunPersonalizedRoots({ reason: 'purchase-event', forceCart: true });
  };

  const handlePrivacyChange = () => {
    if (!behaviorTrackingAllowed()) {
      removeStoredInteractions();
      recordedCurrentPageHandles.clear();
    } else {
      trackCurrentProductPage();
    }
    recordedReferrerHandles.clear();
    rerunPersonalizedRoots({ reason: 'privacy-change', forceCart: true });
  };

  const handlePageShow = (event) => {
    if (!event?.persisted) return;
    invalidateCart();
    rerunPersonalizedRoots({ reason: 'page-return', forceCart: true });
  };

  const handleCrossTabInteraction = () => {
    rerunPersonalizedRoots({ reason: 'cross-tab-interaction', forceCart: false });
  };

  const handleStorageChange = (event) => {
    if (
      event.key === STORAGE_KEY ||
      event.key === FATIGUE_STORAGE_KEY ||
      LEGACY_STORAGE_KEYS.includes(event.key)
    ) {
      handleCrossTabInteraction();
    }
  };

  interactionChannel?.addEventListener('message', (event) => {
    if (event.data?.type === 'interaction-update') handleCrossTabInteraction();
  });

  const destroyAll = () => {
    window.clearTimeout(globalRerunTimer);
    window.clearTimeout(cartRefreshTimer);
    window.clearTimeout(cartVerificationTimer);
    document.querySelectorAll(ROOT_SELECTOR).forEach(destroyRoot);
    globalLifecycle.abort();
    try {
      interactionChannel?.close();
    } catch (_error) {
      // Best effort.
    }
    window[GLOBAL_KEY] = null;
  };

  window.addEventListener('storage', handleStorageChange, {
    signal: globalLifecycle.signal,
  });

  document.addEventListener('click', handleStorefrontProductClick, {
    capture: true,
    signal: globalLifecycle.signal,
  });

  window.addEventListener('pageshow', handlePageShow, {
    signal: globalLifecycle.signal,
  });

  document.addEventListener('shopify:section:load', (event) => initialize(event.target), {
    signal: globalLifecycle.signal,
  });
  document.addEventListener('shopify:section:unload', (event) => destroyInScope(event.target), {
    signal: globalLifecycle.signal,
  });
  document.addEventListener('shopify:block:select', (event) => scrollBlockIntoView(event.target), {
    signal: globalLifecycle.signal,
  });
  document.addEventListener('shopify:cart:lines-update', handleStandardCartLinesUpdate, {
    signal: globalLifecycle.signal,
  });
  document.addEventListener('shopify:cart:update', handleLegacyCartChange, {
    signal: globalLifecycle.signal,
  });
  document.addEventListener('shopify:cart:clear', handleLegacyCartChange, {
    signal: globalLifecycle.signal,
  });
  document.addEventListener('shopify:product:view', handleProductView, {
    signal: globalLifecycle.signal,
  });
  document.addEventListener('z2fc:purchase', handlePurchaseEvent, {
    signal: globalLifecycle.signal,
  });
  document.addEventListener('shopify:checkout:completed', handlePurchaseEvent, {
    signal: globalLifecycle.signal,
  });
  document.addEventListener('visitorConsentCollected', handlePrivacyChange, {
    signal: globalLifecycle.signal,
  });
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', handlePrivacyChange, {
    signal: globalLifecycle.signal,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), {
      once: true,
      signal: globalLifecycle.signal,
    });
  } else {
    initialize(document);
  }

  ensureCustomerPrivacy().then(() => {
    if (!globalLifecycle.signal.aborted) {
      handlePrivacyChange();
      trackCurrentProductPage();
    }
  });

  window[GLOBAL_KEY] = {
    version: VERSION,
    initialize,
    destroyRoot,
    destroyAll,
    personalizeRoot: (root, options = {}) => requestPersonalization(root, options),
    recordInteraction,
    recordPurchase: (products) => handlePurchaseEvent({ detail: { products } }),
    invalidateCart,
    rerun: () => rerunPersonalizedRoots({ reason: 'manual-rerun', forceCart: true }),
    clearPersonalizationData: removeStoredInteractions,
    getDiagnostics: (root = document.querySelector(ROOT_SELECTOR)) =>
      root ? rootStates.get(root)?.lastDiagnostics || null : null,
    getExperimentMetrics: readMetrics,
    __test: {
      tokenize,
      compactSignalFromProduct,
      sanitizeInteraction,
      mergeInteractionRecords,
      inferCategoriesFromTokens,
      classifyCategoryData,
      classifyStrictCategoryData,
      categoryGateAllowsData: (gate, data, source = 'native') => {
        if (gate === 'any') return true;
        if (gate === 'deals') {
          const classification = classifyCategoryData(data);
          if (TRUSTED_CURATED_SOURCES.has(source) && source !== 'native') return true;
          return APPROVED_DEAL_CATEGORIES.has(classification.category);
        }
        return classifyStrictCategoryData(data).category === gate;
      },
      selectNativeSourceIds,
      getProductHandleFromPath,
      sanitizeRemoteProfile,
      fetchNativeRecommendations,
    },
  };
})();